import React, { useState, useEffect, useRef, forwardRef } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { store } from "../../Store/store";
import "../../Complaint.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import toast from "react-hot-toast";
import * as DashboardService from "../../Services/Dashboard/DashboardService";
import * as AttachmentService from "../../Services/Attachment/AttachmentService";
import * as AccountService from "../../Services/Account/AccountService";
import * as B2BRegistrationService from "../../Services/B2BRegistration/B2BRegistrationService";
import { FaCamera, FaCheck, FaEye, FaSearch, FaSpinner, FaWpforms } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { subYears, subMonths, subWeeks, subDays, differenceInYears, differenceInMonths, differenceInWeeks, differenceInDays, set } from "date-fns";
import { formatDate, formatVisitDate, CONTAINERSIZEVALIDATION } from "../../Common/CommonVariables";
import FilePreviewModal from "../../Common/FilePreviewModal";
import { Calendar, Loader2 } from "lucide-react";
import MultiSelect from 'multiselect-react-dropdown';
import Popover from '../../Common/Popper';
import { FaToggleOn, FaToggleOff, FaPen, FaBars, FaTrash, FaPlus } from "react-icons/fa";
import { Toaster } from 'react-hot-toast';
import '../../Complaint.css';
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./B2BRegistration.css";
import CameraComponent from "./CameraComponent";
import BarcodeScannerComponent from "../../Common/BarcodeScannerComponent";

const B2bRegistrationComponent = () => {
    // Ref for Tests section to scroll on error
    const testsSectionRef = useRef(null);
    const docsButtonRefs = useRef([])
    const navigate = useNavigate();

    const userInfo = store.getState();
    const selectedOrg = useSelector((state) => state.selectedOrganization);

    const { register, handleSubmit, setValue, getValues, reset, watch, trigger, formState: { errors } } = useForm();

    const [SearchLoading, setSearchLoading] = useState(false);
    const [loadingItem, setLoadingItem] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const selectedSearchTestName = useRef();
    const [searchTestText, setSearchTestText] = useState(null);
    const [testCodeSearchData, setTestCodeSearchData] = useState([]);
    const [selectedTests, setSelectedTests] = useState([]);
    // const [hasAnyHistory, setHasAnyHistory] = useState([]);
    const [activePatientHistoryList, setActivePatientHistoryList] = useState([]);
    const [selectedPatientHistoryList, setSelectedPatientHistoryList] = useState([]);

    const selectLocation = useRef();
    const [activeOrgLocationListData, setActiveOrgLocationListData] = useState([]);
    const [activePatientAttachmentListData, setActivePatientAttachmentListData] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState();
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isUploading, setIsUploading] = useState(false)
    const [isUploadingForHistory, setIsUploadingForHistory] = useState(false)
    const [suggestionButtonLoading , setSuggestionButtonLoading] = useState(false)

    const accountDetails = userInfo?.Partner_Account_Details;
    const userDetails = userInfo?.userData;

    const [sampleCollectionDateTime, setSampleCollectionDateTime] = useState("");
    const [suggestionModel, setSuggestionModel] = useState(false);
    const [testSuggestions, setTestSuggestions] = useState([])

    const [searchText, setSearchText] = useState("");
    const [filteredTests, setFilteredTests] = useState([]);

    useEffect(() => {
        GetPartnerFrequentAddedTestMasterList();
    }, []);

    const GetPartnerFrequentAddedTestMasterList = () => {
        B2BRegistrationService.GetPartnerFrequentAddedTestMasterList(userDetails?.Partner_Code)
            .then(({ data }) => {
                if (data?.IsSuccess && data?.Data?.length) {
                    setTestSuggestions(data.Data);
                    setFilteredTests(data.Data);
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => setSearchLoading(false));
    }


    // // Format datetime for <input type="datetime-local">
    // const formatDateTime = (date) => {
    //     return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    //         .toISOString()
    //         .slice(0, 16);
    // };

    // // Get today's max datetime (today 23:59)
    // const getTodayMaxDateTime = () => {
    //     const now = new Date();
    //     now.setHours(23, 59, 0, 0);
    //     return formatDateTime(now);
    // };

    // Format date to "yyyy-MM-ddTHH:mm" for datetime-local
    const formatDateTime = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    // Minimum date last 7 days
    const getMinDateTime = () => {
        const minDate = new Date();
        minDate.setDate(minDate.getDate() - 7);
        minDate.setHours(0, 0, 0, 0);
        return formatDateTime(minDate);
    };

    // Today's max datetime
    const getTodayMaxDateTime = () => {
        const now = new Date();
        now.setHours(23, 59, 0, 0);
        return formatDateTime(now);
    };

    // Handler to prevent typing lower than min
    // const handleSampleCollectionChange = (e) => {
    //     const value = e.target.value;
    //     if (!value) return setSampleCollectionDateTime("");

    //     const selectedDate = new Date(value);
    //     const minDate = new Date(getMinDateTime());
    //     const maxDate = new Date(getTodayMaxDateTime());

    //     if (selectedDate < minDate) {
    //         setSampleCollectionDateTime(formatDateTime(minDate));
    //     } else if (selectedDate > maxDate) {
    //         setSampleCollectionDateTime(formatDateTime(maxDate));
    //     } else {
    //         setSampleCollectionDateTime(value);
    //     }
    // };

    const handleTyping = (e) => {
        setSampleCollectionDateTime(e.target.value);
    };

    const handleValidate = () => {
        if (!sampleCollectionDateTime) {
            setSampleCollectionDateTime(getTodayMaxDateTime());
            return;
        }

        const selectedDate = new Date(sampleCollectionDateTime);

        if (isNaN(selectedDate.getTime())) {
            setSampleCollectionDateTime(getMinDateTime());
            return;
        }

        const minDate = new Date(getMinDateTime());
        const maxDate = new Date(getTodayMaxDateTime());

        if (selectedDate < minDate) {
            setSampleCollectionDateTime(formatDateTime(minDate));
        } else if (selectedDate > maxDate) {
            setSampleCollectionDateTime(formatDateTime(maxDate));
        } else {
            setSampleCollectionDateTime(formatDateTime(selectedDate));
        }
    };



    // Set default value to current datetime on load
    useEffect(() => {
        setSampleCollectionDateTime(formatDateTime(new Date()));
    }, []);

    // useEffect(() => {
    //     if (selectedOrg) {
    //         fetchPtientReportList();
    //     }
    // }, [selectedOrg]);

    useEffect(() => {
        if (activeOrgLocationListData.length === 1) {
            const onlyItem = activeOrgLocationListData[0];
            if (selectLocation.current) {
                selectLocation.current.value = onlyItem.OrgLocationId;
                setSelectedLocation(onlyItem);
            }
        }
    }, [activeOrgLocationListData]);
    const printRef = useRef();


    // const dispatch = useDispatch();
    const prevOrgRef = useRef(selectedOrg);

    useEffect(() => {
        if (!prevOrgRef.current) {
            prevOrgRef.current = selectedOrg;
            return;
        }

        if (prevOrgRef.current?.MHL_Org_Id__c !== selectedOrg?.MHL_Org_Id__c) {

            Swal.fire({
                icon: "warning",
                title: "Organization Changed",
                text: "Selected organization has been changed. Form will reload.",
                confirmButtonText: "OK"
            }).then(() => {
                prevOrgRef.current = selectedOrg;
                reset();
                setSelectedTests([]);
                setActiveOrgLocationListData([]);
                setSelectedLocation("");
                setTestSampleContainerList([]);
                setTotalContainers(0);
                setContainerAggregation({});
                window.location.reload();
            });
        }
    }, [selectedOrg]);

    const validateLocationBeforeAction = () => {
        const loc = selectLocation.current?.value;

        if (!loc || loc === "") {
            toast.error("Please select location first.");
            return false;
        }
        return true;
    };


    // const validateRequestBody = (requestBody) => {
    //     if (!requestBody.PatientTestList || requestBody.PatientTestList.length === 0) {
    //         toast.error("Please select at least one test.");
    //         return false;
    //     }

    //     // 2. History validation
    //     const invalidTests = requestBody.PatientTestList.filter(test => {
    //         if (test.IsRequiredHistory) {
    //             const historyList = test.PatientHistoryAttribute || [];
    //             return historyList.length === 0 ||
    //                 historyList.some(h => !h?.HistoryValue || h.HistoryValue.trim() === "");
    //         }
    //         return false;
    //     });

    //     if (invalidTests.length > 0) {
    //         const missingTestCodes = invalidTests.map(t => t.TestCode).join(", ");
    //         toast.error(`Add history data for: ${missingTestCodes}`);
    //         return false;
    //     }

    //     return true;
    // };
    const validateRequestBody = async (requestBody) => {

        if (accountDetails.MHL_Status__c !== "Active") {
            Swal.fire({
                icon: "warning",
                title: "Action Not Allowed",
                text: "You don’t have permission to perform registration. Please contact MHL Admin for assistance.",
                confirmButtonText: "OK",
            });
            return;
        }

        if (!requestBody.PatientTestList || requestBody.PatientTestList.length === 0) {
            toast.error("Please select at least one test.");
            return false;
        }

        const userGender = requestBody.Gender?.trim()?.toLowerCase();

        // --- Gender validation ---
        if (userGender) {
            const invalidGenderTests = requestBody.PatientTestList.filter(t => {
                const testGender = t.Gender?.trim()?.toLowerCase();

                if (!testGender) return false; // No gender restriction → valid
                if (testGender === "both" && ["male", "female", "na", "transgender"].includes(userGender)) return false;
                if (testGender === "female" && userGender === "female") return false;
                if (testGender === "male" && userGender === "male") return false;
                // if ((testGender === "na" || testGender === "na") && userGender === "other") return false;
                if (testGender === "veterinary" && userGender === "veterinary") return false;

                return true; // invalid
            });

            if (invalidGenderTests.length > 0) {
                const invalidCodes = invalidGenderTests.map(t => t.TestCode).join(", ");
                toast.error(`Following tests are not applicable for selected gender: ${invalidCodes}. Please remove them.`);
                return false;
            }
        }

        // --- History validation ---
        const invalidTests = requestBody.PatientTestList.filter(test => {
            if (test.IsRequiredHistory) {
                const historyList = test.PatientHistoryAttribute || [];
                return historyList.length === 0 ||
                    historyList.some(h => !h?.HistoryValue || h.HistoryValue.trim() === "");
            }
            return false;
        });

        // if (invalidTests.length > 0) {
        //     const missingTestCodes = invalidTests.map(t => t.TestCode).join(", ");
        //     toast.error(`Add history data for: ${missingTestCodes}`);
        //     // Scroll to Tests section
        //     setTimeout(() => {
        //         if (testsSectionRef.current) {
        //             testsSectionRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        //         }
        //     }, 200);
        //     return false;
        // }


        if (invalidTests.length > 0) {
            const missingTestCodes = invalidTests.map(t => t.TestCode).join(", ");
            toast.error(
                <div>
                    Please update mandatory documents required for added investigations:{" "}
                    <b>{missingTestCodes}</b>
                </div>
            );

            requestBody.PatientTestList.forEach((t, idx) => {
                const isInvalid = invalidTests.some(invalid => invalid.TestCode === t.TestCode);
                if (isInvalid) {
                    const buttonEl = docsButtonRefs.current[idx];
                    if (buttonEl) {
                        buttonEl.classList.add("highlight-docs-btn");

                        const removeHighlight = () => {
                            buttonEl.classList.remove("highlight-docs-btn");
                            buttonEl.removeEventListener("click", removeHighlight);
                        };
                        buttonEl.addEventListener("click", removeHighlight);
                    }
                }
            });

            const firstInvalidIndex = requestBody.PatientTestList.findIndex(t =>
                invalidTests.some(invalid => invalid.TestCode === t.TestCode)
            );

            setTimeout(() => {
                const firstButton = docsButtonRefs.current[firstInvalidIndex];
                if (firstButton) {
                    firstButton.scrollIntoView({ behavior: "smooth", block: "center" });
                }
            }, 300);

            return false;
        }

        // --- Balance validation (async) ---
        if (accountDetails.MHL_Payment_Type__c === "Rolling Advance") {
            try {
                const { data } = await B2BRegistrationService.GetAccountBalanceDetails(accountDetails.MHL_Client_Code__c);

                if (data?.IsSuccess) {
                    const balance = Number(data.Data.BalanceRollingAdvanceAmount || 0);
                    const total = Number(requestBody.TotalAmount || 0);

                    if (balance < total) {
                        toast.error("Insufficient Balance.");
                        return false;
                    }
                } else {
                    toast.error("Unable to fetch account balance.");
                    return false;
                }
            } catch (error) {
                toast.error("Something went wrong while checking balance.");
                return false;
            }
        }

        // --- Barcode validation ---
        if (userDetails?.Is_Avail_For_PrePrintedBarcode) {
            const seenBarcodes = new Set();
            for (const test of requestBody.TestSampleContainerList) {
                const { BarcodeId, sampleType, sampleContainer } = test;

                const containerName = sampleContainer.trim().toUpperCase();
                const sampleName = sampleType.trim().toUpperCase();

                // Skip validation for "NO CONTAINER" or "NO SAMPLE"
                if (containerName === "NO CONTAINER" || sampleName === "NO SAMPLE") {
                    continue;
                }

                // 1. BarcodeId must not be empty
                if (!BarcodeId || BarcodeId.trim() === "") {
                    toast.error(
                        `Invalid barcode data: SampleType: ${sampleType}, Container: ${sampleContainer}, BarcodeId: EMPTY`
                    );
                    return false;
                }

                // 2. ContainerSize must match fixed validation size
                if (BarcodeId.length !== CONTAINERSIZEVALIDATION) {
                    toast.error(
                        `Invalid barcode length for Container: ${sampleContainer}(${sampleName}), BarcodeId: ${BarcodeId}`
                    );
                    return false;
                }

                // 3. Duplicate check for same container + barcode
                const key = `${containerName}_${BarcodeId}`;
                if (seenBarcodes.has(key)) {
                    toast.error(
                        `Duplicate barcode detected for Container: ${sampleContainer}(${sampleName}), BarcodeId: ${BarcodeId}`
                    );
                    return false;
                }
                seenBarcodes.add(key);

                // 4. API validation
                try {
                    const { data } = await B2BRegistrationService.ValidateContainerBarcodeId(sampleContainer, BarcodeId);
                    if (!data.IsSuccess) {
                        toast.error(
                            `Invalid container barcode: [SampleType: ${sampleType}] [Container: ${sampleContainer}] [BarcodeId: ${BarcodeId}] | ${data.ResponseMessage}`
                        );

                        return false;
                    }
                } catch (error) {
                    toast.error("Something went wrong while validating container barcode.");
                    return false;
                }
            }
        }

        return true; //  all validations passed
    };


    const [previewData, setPreviewData] = useState(null);
    const [showPreview, setShowPreview] = useState(false);

    // const onSubmit = (data) => {

    //     const totalAmount = selectedTests.reduce((sum, t) => {
    //         const value = parseFloat(t.NetMrp) || 0;
    //         return sum + value;
    //     }, 0);

    //     const requestBody = {
    //         Salutation: data.salutation,
    //         FirstName: data.firstName,
    //         MiddleName: data.middleName,
    //         LastName: data.lastName,
    //         Gender: data.gender,
    //         Dob: data.dob,
    //         Age: data.age,
    //         MobileNumber: data.mobile,
    //         Email: data.email,
    //         DoctorName: data.doctorName,
    //         Address1: data.address1,
    //         Address2: data.address2,
    //         Pincode: data.pincode,
    //         OrgId: parseInt(selectedOrg?.MHL_Org_Id__c),
    //         OrgName: selectedOrg?.MHL_Organization_Name,
    //         OrgLocationId: parseInt(selectedLocation?.OrgLocationId) || 0,
    //         OrgLocationName: selectedLocation?.OrgLocationName || "",
    //         PatientTestList: selectedTests.map(t => ({
    //             IsManualTest: t.IsManualTest,
    //             TestCode: t.TestCode,
    //             TestName: t.TestName,
    //             TestType: t.TestType,
    //             Gender: t.Gender,
    //             ProcessingLocation: t.ProcessingLocation,
    //             TestTat: t.TestTat || "",
    //             Remarks: t.Remarks || "",
    //             Mrp: t.Mrp || "",
    //             NetMrp: t.NetMrp || "",
    //             PackageTestConfigList: t.PackageTestConfigList || {},
    //             IsRequiredHistory: t.IsHistory,
    //             PatientHistoryAttribute: t.HistoryAttribute || []
    //         })),
    //         PatientHistory: selectedPatientHistoryList || [],
    //         TestSampleContainerList: [],
    //         Remarks: testRemarksRef.current?.value,
    //         SampleCollectionDateTime: sampleCollectionDateTime,
    //         TotalAmount: totalAmount,
    //         PatientAttachmentList: patientAttachments
    //     };


    //     //console.log("TRF Form Submitted: ", requestBody);

    //     if (!validateRequestBody(requestBody)) return;

    //     //console.log("TRF Form Submitted: ", requestBody);
    //     toast.success("Form submitted.");

    //     B2BRegistrationService.CreateB2BRegistration(requestBody)
    //         .then(({ data }) => {
    //             if (data?.IsSuccess && data?.Data?.length) {
    //                 // handle success
    //             }
    //         })
    //         .catch(() => toast.error("Something went wrong."))
    //         .finally(() => { });
    // };

    // const [TRFID, setTRFID] = useState("");
    function generateTRF(partnerCode, orgId) {
        const now = new Date();

        const yy = now.getFullYear().toString().slice(-2); // last 2 digits of year
        const MM = String(now.getMonth() + 1).padStart(2, "0"); // month (01-12)
        const dd = String(now.getDate()).padStart(2, "0"); // day (01-31)
        const HH = String(now.getHours()).padStart(2, "0"); // hours (00-23)
        const mm = String(now.getMinutes()).padStart(2, "0"); // minutes (00-59)
        const ss = String(now.getSeconds()).padStart(2, "0"); // seconds (00-59)
        const ff = String(Math.floor(now.getMilliseconds() / 10)).padStart(2, "0"); // hundredths of a second

        const dateTimeStr = `${yy}${MM}${dd}${HH}${mm}${ss}${ff}`;

        return `TRFP${partnerCode}${orgId}${dateTimeStr}`;
    }


    const onSubmit = async (data) => {

        // setTRFID(generateTRF(userInfo?.Partner_Account_Details?.MHL_Client_Code__c, parseInt(selectedOrg?.MHL_Org_Id__c)));
        const totalAmount = selectedTests.reduce((sum, t) => {
            const value = parseFloat(t.NetMrp) || 0;
            return sum + value;
        }, 0);

        //console.log("TRFID: ", data.TRFID)
        const requestBody = {
            TRFID: data.TRFID,
            Salutation: data.salutation,
            FirstName: data.firstName,
            MiddleName: data.middleName,
            LastName: data.lastName,
            Gender: data.gender,
            Dob: data.dob,
            Age: data.age,
            PatientAge: data.patientAge,
            PincodeAddress: data.PincodeAddress,
            MobileNumber: data.mobile,
            Email: data.email,
            DoctorName: data.doctorName,
            Address1: data.address1,
            Address2: data.address2,
            Pincode: data.pincode,
            OrgId: parseInt(selectedOrg?.MHL_Org_Id__c),
            OrgName: selectedOrg?.MHL_Organization_Name,
            OrgLocationId: parseInt(selectedLocation?.OrgLocationId) || 0,
            OrgLocationName: selectedLocation?.OrgLocationName || "",
            PatientTestList: selectedTests.map((t) => ({
                IsManualTest: t.IsManualTest,
                TestCode: t.TestCode,
                TestName: t.TestName,
                TestType: t.TestType,
                Gender: t.Gender,
                ProcessingLocation: t.ProcessingLocation,
                TestTat: t.TestTat || "",
                Remarks: t.Remarks || "",
                Mrp: t.Mrp || "",
                NetMrp: t.NetMrp || "",
                PackageTestConfigList: t.PackageTestConfigList || {},
                IsRequiredHistory: t.IsHistory,
                PatientHistoryAttribute: t.HistoryAttribute || [],
            })),
            // PatientHistory: selectedPatientHistoryList || [],
            PatientHistory: selectedPatientHistoryList.map(item => item.Value.trim()) || [],
            // Remarks: testRemarksRef.current?.value,
            Remarks: data.additionalInfo,
            TotalAmount: totalAmount,
            PatientAttachmentList: patientAttachments,

            SampleCollectionDateTime: sampleCollectionDateTime,
            TestSampleContainerList: testSampleContainerList,
        };
        //debugger;
        //console.log(requestBody)
        //  await validation
        const isValid = await validateRequestBody(requestBody);
        if (!isValid) return;

        //  show preview only if valid
        setPreviewData(requestBody);
        setShowPreview(true);
    };


    // const handleConfirmSubmit = () => {
    //     if (!previewData) return;

    //     setIsSubmitting(true)
    //     setSearchLoading(true);
    //     B2BRegistrationService.CreateB2BRegistration(previewData)
    //         .then(({ data }) => {
    //             if (data.IsSuccess) {
    //                 toast.success("Registration Completed successfully.");
    //                 setShowPreview(false);
    //                 reset();
    //                 //console.log("Registration Response Data:", data.Data);

    //                 // Popup after success
    //                 Swal.fire({
    //                     title: "Registration Completed",
    //                     text: "Do you want to view TRF or go to Registration List?",
    //                     icon: "success",
    //                     iconColor: "#00984A",
    //                     showCancelButton: true,
    //                     confirmButtonText: "View TRF",
    //                     cancelButtonText: "Go to Registration List",
    //                     confirmButtonColor: "#00984A",
    //                     cancelButtonColor: "#d33"
    //                 }).then((result) => {
    //                     //debugger;
    //                     if (result.isConfirmed) {
    //                         //debugger;
    //                         if (data.Data.trfPath) {
    //                             const newWindow = window.open(data.Data.trfPath, "_blank");
    //                             if (newWindow) {
    //                                 newWindow.focus();
    //                                 newWindow.print();
    //                             }
    //                         }
    //                         // redirect after opening TRF
    //                         navigate("/registrationlist");
    //                     } else {
    //                         navigate("/registrationlist");
    //                     }
    //                 });

    //             } else {
    //                 setSearchLoading(false);
    //                 setIsSubmitting(false)
    //                 toast.error(data.ResponseMessage);
    //                 setShowPreview(false);
    //             }
    //         })
    //         .catch(() => toast.error("Something went wrong."))
    //         .finally(() => {
    //             setSearchLoading(false);
    //             setIsSubmitting(false)
    //         });
    // };

    const handleConfirmSubmit = () => {
        if (!previewData) return;

        setIsSubmitting(true);
        setSearchLoading(true);

        B2BRegistrationService.CreateB2BRegistration(previewData)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    toast.success("Registration Completed successfully.");
                    setShowPreview(false);
                    reset();
                    //console.log("Registration Response Data:", data.Data);

                    // Popup after success
                    Swal.fire({
                        title: "Registration Completed",
                        html: `
                       <div style="text-align: left;">
                        <p>
                            TRF ID: <strong>${data.Data.trfId || "N/A"}</strong> has been successfully registered. 
                            You can now view the TRF or return to the Registration List.
                        </p>
                    </div>
                    `,
                        icon: "success",
                        iconColor: "#00984A",
                        showCancelButton: true,
                        confirmButtonText: "View TRF",
                        cancelButtonText: "Go to Registration List",
                        confirmButtonColor: "#00984A",
                        cancelButtonColor: "#d33"
                    }).then((result) => {
                        if (result.isConfirmed) {
                            if (data.Data.trfPath) {
                                const newWindow = window.open(data.Data.showTRFBaseURL ? data.Data.trfBaseURL : data.Data.trfPath, "_blank");
                                if (newWindow) {
                                    newWindow.focus();
                                    newWindow.print();
                                }
                            }
                            // Redirect after opening TRF
                            navigate("/registrationlist");
                        } else {
                            navigate("/registrationlist");
                        }
                    });
                } else {
                    // setSearchLoading(false);
                    // setIsSubmitting(false);
                    // toast.error(data.ResponseMessage);
                    // setShowPreview(false);

                    setSearchLoading(false);
                    setIsSubmitting(false);
                    setShowPreview(false);
                    toast.error(data.ResponseMessage || "Navigation to Registration List.");

                    const trfId = getValues("TRFID");

                    // Popup after failure with no retry but note and go to TRF list
                    Swal.fire({
                        title: "Registration Failed",
                        html: `
                        <div style="text-align: left;">
                            <p>
                                TRF Registration Failed                             <br/>
                                Reason:  ${data.ResponseMessage || "Please try again later."}.<br/>
                            </p></br/>                
                        </div>
                    `,
                        icon: "error",
                        iconColor: "#d33",
                        confirmButtonText: "Go to TRF List",
                        confirmButtonColor: "#d33"
                    }).then(() => {
                        navigate("/registrationlist"); // Navigate to registration list
                    });
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => {
                setSearchLoading(false);
                setIsSubmitting(false);
            });
    };

    const testRemarksRef = useRef(null);

    const startDateRef = useRef(null);
    // const dob = watch("dob");

    useEffect(() => {

        if (selectedOrg) {
            GetPatientHistoryList();
            GetOrgLocationListByOrgId();
            GetAttachmentOptionList();
        }
    }, [selectedOrg])

    const [dob, setDob] = useState(null);
    const [ageValue, setAgeValue] = useState("");
    const [ageUnit, setAgeUnit] = useState("Year");
    // const startDateRef = useRef();


    const calculateAgeFromDOB = (date) => {
        if (!date) return;

        const today = new Date();
        const birthDate = new Date(date);

        let years = differenceInYears(today, birthDate);
        let months = differenceInMonths(today, birthDate) - years * 12;
        let weeks = differenceInWeeks(today, birthDate) - (years * 12 * 4 + months * 4);
        let days = differenceInDays(today, birthDate);

        let formattedAge = "";

        if (years > 0) {
            // Always show months as two digits
            let monthsStr = months > 0 ? String(months).padStart(2, '0') : '00';
            let decimalAge = `${years}.${monthsStr}`;
            setAgeValue(decimalAge);
            setAgeUnit("Year");
            formattedAge = `${decimalAge} Year(s)`;
        } else if (months > 0) {
            setAgeValue(months);
            setAgeUnit("Month");
            formattedAge = `${months} Month(s)`;
        } else if (weeks > 0) {
            setAgeValue(weeks);
            setAgeUnit("Week");
            formattedAge = `${weeks} Week(s)`;
        } else {
            setAgeValue(days);
            setAgeUnit("Day");
            formattedAge = `${days} Day(s)`;
        }

        setValue("patientAge", formattedAge);
    };


    const calculateDOBFromAge = (value, unit) => {
        if (!value) return;
        const today = new Date();
        let newDOB;

        if (unit === "Year") {
            let [years, months] = value.split(".");
            years = parseInt(years) || 0;
            months = parseInt(months) || 0;
            newDOB = subYears(today, years);
            if (months > 0) {
                newDOB = subMonths(newDOB, months);
            }
        } else if (unit === "Month") {
            newDOB = subMonths(today, parseInt(value));
        } else if (unit === "Week") {
            newDOB = subWeeks(today, parseInt(value));
        } else if (unit === "Day") {
            newDOB = subDays(today, parseInt(value));
        }

        setDob(newDOB);
        setValue("dob", newDOB);
        setValue("patientAge", `${value} ${unit}(s)`);
    };

    const MIN_DOB = new Date(1900, 0, 1);

    // useEffect(() => {
    //     if (dob) {
    //         setValue("dateofbirth", formatDate(dob))
    //         const ageText = calculateAge(dob);
    //         setValue("age", ageText);
    //     }
    // }, [dob, setValue]);

    // import { differenceInYears, differenceInMonths, differenceInDays } from "date-fns";

    // const calculateAge = (dob) => {
    //     if (!dob) return "";

    //     const today = new Date();
    //     const birthDate = new Date(dob);

    //     let years = differenceInYears(today, birthDate);
    //     let months = differenceInMonths(today, birthDate) - years * 12;
    //     let days = differenceInDays(today, birthDate);

    //     // Case: less than 1 month old → show days
    //     if (years === 0 && months === 0) {
    //         return `${days} Day${days > 1 ? "s" : ""}`;
    //     }

    //     // Case: years and months
    //     let yearStr = years > 0 ? `${years} Year${years > 1 ? "s" : ""}` : "";
    //     let monthStr = months > 0 ? `${months} Month${months > 1 ? "s" : ""}` : "";

    //     return [yearStr, monthStr].filter(Boolean).join(" ").trim();
    // };



    const searchRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const fetchRateCard = async () => {
        if (!validateLocationBeforeAction()) return;
        const isValid = await trigger(["salutation", "firstName", "gender", "dob", "age", "pincode"]);

        if (!isValid) {
            toast.error("Please enter mandatory fields.");
            return;
        }

        //debugger;
        const query = selectedSearchTestName.current?.value?.trim() || searchTestText?.trim() || "";

        if (!query) {
            toast.error("Please enter search keyword.");
            return;
        }

        var gender = getValues("gender");

        setSearchLoading(true);
        setTestCodeSearchData([]);
        const requestData = {
            clientCode: userInfo?.Partner_Account_Details?.MHL_Client_Code__c,
            testSearch: query,
            orgId: selectedOrg?.MHL_Org_Id__c,
            Gender: gender
        };

        B2BRegistrationService.UniversalSearchTestDetailByTestCode(requestData)
            .then(({ data }) => {
                if (data?.IsSuccess && data?.Data?.length) {
                    setTestCodeSearchData(data.Data);
                    setShowDropdown(true);
                } else {
                    setShowDropdown(false);
                    toast.error("No test found.");
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => setSearchLoading(false));
    };

    const fetchRateCardForSuggestions = async (suggestion_testcode, buttonId) => {
        if (!validateLocationBeforeAction()) return;
        const isValid = await trigger(["salutation", "firstName", "gender", "dob", "age", "pincode"]);

        if (!isValid) {
            toast.error("Please enter mandatory fields.");
            return;
        }

        
        var gender = getValues("gender");
        
        setLoadingItem(buttonId);
        setSuggestionButtonLoading(true)
        setSearchLoading(true);
        setTestCodeSearchData([]);
        const requestData = {
            clientCode: userInfo?.Partner_Account_Details?.MHL_Client_Code__c,
            testSearch: suggestion_testcode,
            orgId: selectedOrg?.MHL_Org_Id__c,
            Gender: gender
        };

        B2BRegistrationService.UniversalSearchTestDetailByTestCode(requestData)
            .then(({ data }) => {
                if (data?.IsSuccess && data?.Data?.length) {
                    setTestCodeSearchData(data.Data);

                    const selectedTestFromSuggestion_Data = data?.Data.find(
                        test => test.TestCode === suggestion_testcode
                    );

                    handleAddTest(selectedTestFromSuggestion_Data);
                } else {
                    setShowDropdown(false);
                    toast.error("No test found.");
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => {setSearchLoading(false); setLoadingItem(null); setSuggestionButtonLoading(false)});
    };

    const [selectedGroupingOfTests, setSelectedGroupingOfTests] = useState({ addedTests: "", addedGrps: "", addedPkgs: "", addedGbis: "" });

    const handleAddTest = async (test) => {
        if (!validateLocationBeforeAction()) return;
        const isValid = await trigger(["salutation", "firstName", "gender", "dob", "age", "pincode"]);

        if (!isValid) {
            toast.error("Please enter mandatory fields.");
            return;
        }
        const exists = selectedTests.find((t) => t.TestCode === test.TestCode);
        if (exists) {
            toast.error("Test already added.");
            setSearchLoading(false)
            setLoadingItem(null);
            return;
        }

        //console.log("selectedtest", test);

        //  Group them after adding
        const addedTestsArr = selectedTests
            .filter((t) => t.TestType === "INV")
            .map((t) => t.TestCode);
        const addedGrpsArr = selectedTests
            .filter((t) => t.TestType === "GRP")
            .map((t) => t.TestCode);
        const addedPkgsArr = selectedTests
            .filter((t) => t.TestType === "PKG")
            .map((t) => t.TestCode);
        const addedGbisArr = selectedTests
            .filter((t) => t.TestType === "GBI")
            .map((t) => t.TestCode);

        setSelectedGroupingOfTests({
            addedTests: addedTestsArr.join(","),
            addedGrps: addedGrpsArr.join(","),
            addedPkgs: addedPkgsArr.join(","),
            addedGbis: addedGbisArr.join(",")
        });

        const tatRequestData = {
            TestCode: test.TestCode,
            TestType: test.TestType,
            ClientID: userInfo?.Partner_Account_Details?.MHL_Client_Code__c,
            OrgId: selectedOrg?.MHL_Org_Id__c,
            LocationId: selectLocation.current.value || "",
            addedTests: addedTestsArr.join(","),
            addedGrps: addedGrpsArr.join(","),
            addedPkgs: addedPkgsArr.join(","),
            addedGbis: addedGbisArr.join(",")
        };

        B2BRegistrationService.GetTestTATbyTestCode(tatRequestData)
            .then(({ data }) => {
                //debugger;
                if (data.IsSuccess) {

                    // const hasAnyHistory = selectedTests.some(test => test.IsHistory);
                    // setHasAnyHistory(selectedTests.some(test => test.IsHistory));

                    test.ProcessingLocation = data.Data.validateTest.SuccessResponse.processingLocation;
                    const enrichedTest = {
                        ...test,
                        TestTat: data.Data.tatData.Status === "Success" ? data.Data.tatData.ReportDate : "N/A",
                        ReportTATISO: data.Data.tatData.Status === "Success" ? data.Data.tatData.ReportTATISO : "N/A",
                        IsManualTest: false,
                        IsHistory: data.Data.showHistory,
                        HistoryAttribute: data.Data.formattedList || []
                    };

                    setSelectedTests((prev) => {
                        const updated = [...prev, enrichedTest];

                        //  Group them after adding
                        const addedTestsArr = updated
                            .filter((t) => t.TestType === "INV")
                            .map((t) => t.TestCode);
                        const addedGrpsArr = updated
                            .filter((t) => t.TestType === "GRP")
                            .map((t) => t.TestCode);
                        const addedPkgsArr = updated
                            .filter((t) => t.TestType === "PKG")
                            .map((t) => t.TestCode);
                        const addedGbisArr = updated
                            .filter((t) => t.TestType === "GBI")
                            .map((t) => t.TestCode);

                        setSelectedGroupingOfTests({
                            addedTests: addedTestsArr.join(","),
                            addedGrps: addedGrpsArr.join(","),
                            addedPkgs: addedPkgsArr.join(","),
                            addedGbis: addedGbisArr.join(",")
                        });

                        fetchAndUpdateSampleDetails(updated);

                        return updated;
                    });
                    //debugger;
                    toast.success("Test added.");
                    //console.log("SelectedGroupingOfTests", selectedGroupingOfTests);
                    // handleDeleteTest(undefined);
                } else {
                    // const enrichedTest = {
                    //     ...test,
                    //     TestTat: "N/A",
                    //     IsManualTest: false,
                    //     IsHistory: data.Data.showHistory,
                    //     HistoryAttribute: data.Data.formattedList || []
                    // };

                    // setSelectedTests((prev) => [...prev, enrichedTest]);
                    toast.error(data.ResponseMessage);
                }
            })
            .catch(() => {
                toast.error("Something went wrong.");
            })
            .finally(() => {setSearchLoading(false); setLoadingItem(null)});
    };

    const handleAddTestFromSuggestion = async (rec) => {
        await fetchRateCardForSuggestions(rec?.TestCode, rec?.Id);
    } 

    const hasAnyHistory = selectedTests.some(test => test.IsHistory);
    const [showContainerModal, setShowContainerModal] = useState(false);
    const [selectedTestCode, setSelectedTestCode] = useState('');
    const [containerMatchList, setContainerMatchList] = useState([]);

    const handleContainerClick = (test) => {
        setSelectedTestCode(test.TestCode);
        //debugger;
        // const matches = test.PackageTestConfigList.filter(pkg => {
        //     const codes = pkg.TestCode?.split(',').map(code => code.trim());
        //     return codes.includes(test.TestCode);
        // });

        setContainerMatchList(test.PackageTestConfigList || []);
        setShowContainerModal(true);
    };

    const handleContainerModalClose = () => {
        setShowContainerModal(false);
        setSelectedTestCode('');
        setContainerMatchList([]);
    };


    const handleManualTest = () => {

        const enrichedTest = {
            IsManualTest: true
        };
        setSelectedTests((prev) => [...prev, enrichedTest]);

    };


    const [testSampleContainerList, setTestSampleContainerList] = useState([]);

    const [totalContainers, setTotalContainers] = useState(0);
    const [containerAggregation, setContainerAggregation] = useState({});

    // useEffect(() => {
    //     if (selectedTests.length > 0) {
    //         const fetchData = async () => {
    //             // Prepare grouping payload from updated list
    //             const updatedGrouping = {
    //                 orgLocationId: parseInt(selectLocation.current.value) || 0,
    //                 addedTests: selectedTests.filter((t) => t.TestType === "INV").map((t) => t.TestCode).join(","),
    //                 addedGrps: selectedTests.filter((t) => t.TestType === "GRP").map((t) => t.TestCode).join(","),
    //                 addedPkgs: selectedTests.filter((t) => t.TestType === "PKG").map((t) => t.TestCode).join(","),
    //                 addedGbis: selectedTests.filter((t) => t.TestType === "GBI").map((t) => t.TestCode).join(","),
    //             };

    //             // Call API with updated grouping
    //             B2BRegistrationService.GetTestSampleAndContainerDetailList(updatedGrouping)
    //                 .then(({ data }) => {
    //                     //debugger;
    //                     if (data?.IsSuccess) {
    //                         const sampleList = data.Data;

    //                         setSelectedGroupingOfTests(updatedGrouping);
    //                         setTestSampleContainerList(sampleList);

    //                         //  Calculate Total No of Containers
    //                         const totalContainers = sampleList.reduce(
    //                             (sum, item) => sum + (item.noOfVials || 0),
    //                             0
    //                         );

    //                         //  Aggregate ContainerName & Quantity
    //                         const containerAggregation = sampleList.reduce((acc, item) => {
    //                             acc[item.sampleContainer] =
    //                                 (acc[item.sampleContainer] || 0) + (item.noOfVials || 0);
    //                             return acc;
    //                         }, {});

    //                         setTotalContainers(totalContainers);
    //                         setContainerAggregation(containerAggregation);

    //                         //console.log("Total Containers:", totalContainers);
    //                         //console.log("Container Aggregation:", containerAggregation);
    //                         //console.log("Sample List:", sampleList);

    //                         toast.success("Test removed.");
    //                     } else {
    //                         toast.error("Failed to fetch container details.");
    //                     }
    //                 })
    //                 .catch(() => toast.error("Something went wrong."));
    //         };

    //         fetchData();
    //     }
    // }, [selectedTests]);

    // const handleDeleteTest = (indexToRemove) => {

    //     //debugger;
    //     const updatedTests = selectedTests.filter((_, index) => index !== indexToRemove);

    //     // Prepare grouping payload from updated list
    //     const updatedGrouping = {
    //         orgLocationId: parseInt(selectLocation.current.value) || 0,
    //         addedTests: updatedTests.filter((t) => t.TestType === "INV").map((t) => t.TestCode).join(","),
    //         addedGrps: updatedTests.filter((t) => t.TestType === "GRP").map((t) => t.TestCode).join(","),
    //         addedPkgs: updatedTests.filter((t) => t.TestType === "PKG").map((t) => t.TestCode).join(","),
    //         addedGbis: updatedTests.filter((t) => t.TestType === "GBI").map((t) => t.TestCode).join(","),
    //     };

    //     // Call API with updated grouping
    //     B2BRegistrationService.GetTestSampleAndContainerDetailList(updatedGrouping)
    //         .then(({ data }) => {
    //             //debugger;
    //             if (data?.IsSuccess) {
    //                 const sampleList = data.Data;

    //                 setSelectedTests(updatedTests);
    //                 setSelectedGroupingOfTests(updatedGrouping);
    //                 setTestSampleContainerList(sampleList);

    //                 //  Calculate Total No of Containers
    //                 const totalContainers = sampleList.reduce(
    //                     (sum, item) => sum + (item.noOfVials || 0),
    //                     0
    //                 );

    //                 //  Aggregate ContainerName & Quantity
    //                 const containerAggregation = sampleList.reduce((acc, item) => {
    //                     acc[item.sampleContainer] =
    //                         (acc[item.sampleContainer] || 0) + (item.noOfVials || 0);
    //                     return acc;
    //                 }, {});

    //                 setTotalContainers(totalContainers);
    //                 setContainerAggregation(containerAggregation);

    //                 //console.log("Total Containers:", totalContainers);
    //                 //console.log("Container Aggregation:", containerAggregation);
    //                 //console.log("Sample List:", sampleList);

    //                 toast.success("Test removed.");
    //             } else {
    //                 toast.error("Failed to fetch container details.");
    //             }
    //         })
    //         .catch(() => toast.error("Something went wrong."));
    // };

    //  Helper: Build grouping payload

    const buildGroupingPayload = (tests) => ({
        orgLocationId: parseInt(selectLocation.current.value) || 0,
        addedTests: tests.filter((t) => t.TestType === "INV").map((t) => t.TestCode).join(","),
        addedGrps: tests.filter((t) => t.TestType === "GRP").map((t) => t.TestCode).join(","),
        addedPkgs: tests.filter((t) => t.TestType === "PKG").map((t) => t.TestCode).join(","),
        addedGbis: tests.filter((t) => t.TestType === "GBI").map((t) => t.TestCode).join(","),
    });

    const fetchAndUpdateSampleDetails = async (tests, showToast = false, toastMessage = "Updated successfully") => {
        const updatedGrouping = buildGroupingPayload(tests);

        try {
            const { data } = await B2BRegistrationService.GetTestSampleAndContainerDetailList(updatedGrouping);

            if (data?.IsSuccess) {
                const sampleList = data.Data;

                setSelectedTests(tests);
                setSelectedGroupingOfTests(updatedGrouping);
                setTestSampleContainerList(sampleList);
                //debugger;
                // Calculate total containers
                const totalContainers = sampleList
                    .filter(item => item.sampleContainer !== "NO CONTAINER")
                    .reduce((sum, item) => sum + (item.noOfVials || 0), 0);

                // Aggregate containers
                const containerAggregation = sampleList.reduce((acc, item) => {
                    acc[item.sampleContainer] =
                        (acc[item.sampleContainer] || 0) + (item.noOfVials || 0);
                    return acc;
                }, {});

                setTotalContainers(totalContainers);
                setContainerAggregation(containerAggregation);

                if (showToast) toast.success(toastMessage);
            } else {
                // setTotalContainers([]); setContainerAggregation([]);
                toast.error("Failed to fetch container details.");
            }
        } catch {
            toast.error("Something went wrong.");
        }
    };

    //  useEffect to trigger on add/update
    // useEffect(() => {
    //     if (selectedTests.length > 0) {
    //         fetchAndUpdateSampleDetails(selectedTests);
    //     }
    // }, [selectedTests]);


    //  Delete handler
    const handleDeleteTest = (indexToRemove) => {
        const updatedTests = selectedTests.filter((_, index) => index !== indexToRemove);

        if (!updatedTests || updatedTests.length === 0) {
            setSelectedTests([]);
            setSelectedGroupingOfTests({});
            setTestSampleContainerList([]);
            setTotalContainers(0);
            setContainerAggregation({});
            return true;
        }
        fetchAndUpdateSampleDetails(updatedTests, true, "Test Deleted");
    };


    const handleHistory = (index) => {
        setSelectedTestIndex(index);
        setShowTestHistoryModal(true);
        setHistoryFields(selectedTests[index].HistoryAttribute || []);
    };

    const GetPatientHistoryList = () => {
        B2BRegistrationService.GetPatientHistoryList()
            .then(({ data }) => {
                if (data.IsSuccess) {
                    setActivePatientHistoryList(data.Data);
                } else {
                    setActivePatientHistoryList([]);
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => { });
    };

    const GetOrgLocationListByOrgId = () => {
        B2BRegistrationService.GetOrgLocationListByOrgId(selectedOrg?.MHL_Org_Id__c)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    //console.log(data.Data);
                    setActiveOrgLocationListData(data.Data);
                } else {
                    setActiveOrgLocationListData([]);
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => { });
    };

    const GetAttachmentOptionList = () => {
        B2BRegistrationService.GetAttachmentOptionList()
            .then(({ data }) => {
                if (data.IsSuccess) {
                    //console.log(data.Data);
                    setActivePatientAttachmentListData(data.Data);
                } else {
                    setActivePatientAttachmentListData([]);
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => { });
    };

    const GetPincodeStateDetails = (pincode) => {
        B2BRegistrationService.GetPincodeStateDetails(pincode)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    return true;
                } else {
                    return false;
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => { });
    };

    const handleDownload = () => {
        const url = 'https://mhl-reports.s3.ap-south-1.amazonaws.com/MHL_TRF/TRF/08-08-2025/de4a8e9018474bac9f5e8402142ab63a.pdf?X-Amz-Expires=600&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIASBQVSAYYLHXF5FAZ%2F20250808%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20250808T101735Z&X-Amz-SignedHeaders=host&X-Amz-Signature=b59373293a2d49d59aa33d9669b6c656166289a8ed75f58f432e3c5a3628a02b';
        const fileName = 'logo.png';

        const a = document.createElement('a');
        a.href = url;
        a.setAttribute('download', fileName);
        a.setAttribute('target', '_blank'); // fallback if download attr is blocked
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    const [isExpanded, setIsExpanded] = useState(false);
    const [showReadMore, setShowReadMore] = useState(true);
    const textRef = useRef(null);
    const maxLines = 2

    useEffect(() => {
        const checkTextOverflow = () => {
            if (textRef.current) {
                const lineHeight = parseInt(window.getComputedStyle(textRef.current).lineHeight);
                const maxHeight = lineHeight * maxLines;
                const actualHeight = textRef.current.scrollHeight;

                if (actualHeight > maxHeight) {
                    setShowReadMore(true);
                } else {
                    setShowReadMore(false);
                }
            }
        };

        checkTextOverflow();
        window.addEventListener('resize', checkTextOverflow);

        return () => window.removeEventListener('resize', checkTextOverflow);
    }, [previewData?.Address1, maxLines]);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    const [fileUrl, setFileUrl] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null)

    // // New Function
    // const handleAttachmentDownload = (url) => {
    //     if (!url) {
    //         toast.error("No file URL provided.");
    //         return;
    //     }

    //     B2BRegistrationService.View_UploadedFile(url)
    //         .then(({ data }) => {
    //             if (data.IsSuccess) {
    //                 setPreviewUrl(data.Data);
    //             } else {
    //                 toast.error("Failed to download file.");
    //             }
    //         })
    //         .catch(() => toast.error("Something went wrong while downloading."));
    // };


    // Old function
    const handleAttachmentDownload = (url) => {
        if (!url) {
            toast.error("No file URL provided.");
            return;
        }
        B2BRegistrationService.View_UploadedFile(url)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    window.open(data.Data, '_blank');
                    // setFileUrl(data.Data);
                    // const link = document.createElement('a');
                    // link.href = data.Data;
                    // link.setAttribute('download', 'attachment'); // You can set a default name here
                    // document.body.appendChild(link);
                    // link.click();
                    // document.body.removeChild(link);
                } else {
                    toast.error("Failed to download file.");
                }
            })
            .catch(() => toast.error("Something went wrong while downloading."));
    };

    const handleDeletePatientAttachment = (idx) => {
        setPatientAttachments((prev) => prev.filter((_, i) => i !== idx));
        toast.success("Attachment removed.");
    };


    //patient Attachment handling
    const [selectedDocType, setSelectedDocType] = useState('');
    const [selectedDocTypeId, setSelectedDocTypeId] = useState('');
    const [selectedOf, setSelectedOf] = useState('');
    const [docNumber, setDocNumber] = useState('');
    const [isUrnType, setIsUrnType] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const [showAttachDocumentModal, setShowAttachDocumentModal] = useState(false);
    const [patientAttachments, setPatientAttachments] = useState([]);

    const handleAttachClose = () => {
        setShowAttachDocumentModal(false);
        setSelectedDocType('');
        setSelectedFile(null);
        clearPatientAttachment();
    };

    const validateDocNumber = (type, number) => {
        switch (type) {
            case "Aadhaar Card":
                return /^[2-9][0-9]{11}$/.test(number);
            case "Pan Card":
                return /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(number);
            case "Passport":
                return /^[A-Z0-9]{8}$/.test(number);
            case "Voter Id":
                return /^[A-Z0-9]{1,20}$/.test(number);
            case "Driving Licence":
                // return /^(([A-Z]{2}[0-9]{2})(\s|-))((19|20)[0-9]{2})[0-9]{7,8}$/.test(number);
                //    return /^([A-Z]{2}[0-9]{2})([-\s]?)(19|20[0-9]{2}|[0-9]{4})([0-9]{7,8})$/.test(number);
                return /^((?:[A-Z]{2}[0-9]{2} )|(?:[A-Z]{2}-[0-9]{2}))((19|20)[0-9]{2})[0-9]{7}$/.test(number);
            case "NDHM ID":
                return /^([1-9][0-9]{13})$/.test(number);
            default:
                return /^[A-Z0-9]{1,20}$/i.test(number);
        }

    };
    //  Common file validator
    const validateFile = (file, maxSizeMB = 10) => {
        if (!file) return { isValid: false, error: "No file selected." };

        const allowedExtensions = [
            ".jpg", ".jpeg", ".bitmap", ".pdf", ".doc", ".docx",
            ".tiff", ".msg", ".eml", ".zip"
        ];
        const fileName = file.name.toLowerCase();
        const isValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));
        if (!isValidExtension) {
            return {
                isValid: false,
                error: "Invalid file type. Allowed: JPG, JPEG, BITMAP, PDF, DOC, DOCX, TIFF, MSG, EML, ZIP"
            };
        }

        const maxSize = maxSizeMB * 1024 * 1024;
        if (file.size > maxSize) {
            return { isValid: false, error: `File size must be less than ${maxSizeMB} MB.` };
        }

        return { isValid: true };
    };


    // const handleAttachFile = (e) => {
    //     e.preventDefault();

    //     setIsUploading(true)

    //     if (!selectedDocType || !selectedDocTypeId || !selectedOf || !docNumber || !selectedFile) {
    //         toast.error("Please fill all fields and select a file.");
    //         setIsUploading(false);
    //         return;
    //     }

    //     const { isValid, error } = validateFile(selectedFile);
    //     if (!isValid) {
    //         toast.error(error);
    //         setIsUploading(false);
    //         return;
    //     }

    //     // Validate doc number
    //     if (!validateDocNumber(selectedDocType, docNumber)) {
    //         toast.error(`Invalid ${selectedDocType} number.`);
    //         setIsUploading(false);
    //         return;
    //     }

    //     // Check duplicate by type + of
    //     const isDuplicate = patientAttachments.some(
    //         (att) => att.urnFileType === selectedDocType && att.urnOf === selectedOf
    //     );
    //     if (isDuplicate) {
    //         toast.error(`${selectedDocType} already added for ${selectedOf}.`);
    //         setIsUploading(false);
    //         return;
    //     }

    //     const formData = new FormData();
    //     formData.append("file", selectedFile);

    //     B2BRegistrationService.UploadAttachment(formData)
    //         .then(({ data }) => {
    //             if (data.IsSuccess) {
    //                 const newAttachment = {
    //                     urnFileTypeId: selectedDocTypeId,
    //                     urnFileType: selectedDocType,
    //                     urnOf: selectedOf,
    //                     urnNumber: docNumber,
    //                     urnFilePath: data.Data
    //                 };

    //                 setPatientAttachments((prev) => [...prev, newAttachment]);
    //                 toast.success(<><b>{selectedDocType}&nbsp;</b> Uploaded successfully.</>);

    //                 clearPatientAttachment();
    //                 // handleAttachClose();
    //             } else {
    //                 toast.error("Upload failed.");
    //             }
    //         })
    //         .catch(() => toast.error("Something went wrong."))
    //         .finally(() => setIsUploading(false))
    // };

    const handleAttachFile = (e) => {
        e.preventDefault();
        setIsUploading(true);

        const selectedItem = activePatientAttachmentListData.find(
            (x) => x.Value === selectedDocType
        );
        const isUrnType = selectedItem?.Is_URN === true;

        // Validate mandatory selections before upload
        if (!selectedDocType || !selectedDocTypeId || !selectedFile) {
            toast.error("Please select attachment type and file.");
            setIsUploading(false);
            return;
        }

        // Run validations only if IS_URN === true
        if (isUrnType) {
            if (!selectedOf || !docNumber) {
                toast.error("Please fill Document Of and Document ID.");
                setIsUploading(false);
                return;
            }

            if (!validateDocNumber(selectedDocType, docNumber)) {
                toast.error(`Invalid ${selectedDocType} number.`);
                setIsUploading(false);
                return;
            }

            // const isDuplicate = patientAttachments.some(
            //     (att) => att.urnFileType === selectedDocType && att.urnOf === selectedOf
            // );
            // if (isDuplicate) {
            //     toast.error(`${selectedDocType} already added for ${selectedOf}.`);
            //     setIsUploading(false);
            //     return;
            // }
        }

        const { isValid, error } = validateFile(selectedFile);
        if (!isValid) {
            toast.error(error);
            setIsUploading(false);
            return;
        }

        const formData = new FormData();
        formData.append("file", selectedFile);

        B2BRegistrationService.UploadAttachment(formData)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    const newAttachment = {
                        urnFileTypeId: selectedDocTypeId,
                        urnFileType: selectedDocType,
                        urnOf: isUrnType ? selectedOf : null,
                        urnNumber: isUrnType ? docNumber : null,
                        urnFilePath: data.Data,
                    };

                    setPatientAttachments((prev) => [...prev, newAttachment]);
                    toast.success(<><b>{selectedDocType}</b>&nbsp;Uploaded successfully.</>);
                    clearPatientAttachment();
                } else toast.error("Upload failed.");
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => setIsUploading(false));
    };


    const clearPatientAttachment = () => {
        setSelectedDocType("");
        setSelectedDocTypeId("");
        setSelectedOf("");
        setDocNumber("");
        setSelectedFile(null);

        // Optional: reset file input UI
        if (document.getElementById("uploadPatientFileInput")) {
            document.getElementById("uploadPatientFileInput").value = "";
        }
    }

    const fileInputRefs = useRef([]);

    const handleDeleteHistoryAttachment = (fieldIndex, attIndex) => {
        const updated = [...historyFields];
        const attList = [...(updated[fieldIndex].HistoryAttachments || [])];

        attList.splice(attIndex, 1); // remove specific attachment

        updated[fieldIndex] = {
            ...updated[fieldIndex],
            HistoryAttachments: attList
        };

        setHistoryFields(updated);
        toast.success("Attachment removed.");
    };

    const handleHistoryAttriAttachFile = (index) => {
        const field = historyFields[index];
        const { urnFileType, selectedHistoryFile } = field;

        setIsUploadingForHistory(true)

        // Allow file upload first, then type/id selection
        if (!selectedHistoryFile) {
            toast.error("Please select a file to upload.");
            setIsUploadingForHistory(false)
            return;
        }
        //  validate file
        const { isValid, error } = validateFile(selectedHistoryFile);
        if (!isValid) {
            toast.error(error);
            setIsUploadingForHistory(false)
            return;
        }
        const formData = new FormData();
        formData.append("file", selectedHistoryFile);

        B2BRegistrationService.UploadAttachment(formData)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    const updated = [...historyFields];
                    updated[index] = {
                        ...field,
                        urnFileType,
                        selectedHistoryFile: null,
                        HistoryValue: data.Data,
                        HistoryAttachments: [
                            ...(field.HistoryAttachments || []),
                            {
                                filePath: data.Data,
                                fileType: urnFileType,
                                fileTypeId: field.urnFileTypeId || null
                            }
                        ]
                    };

                    setHistoryFields(updated);
                    toast.success("Document uploaded successfully.");
                } else {
                    toast.error("Upload failed.");
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => setIsUploadingForHistory(false))
        if (fileInputRefs.current[index]) {
            fileInputRefs.current[index].value = "";
            setSelectedFile(null)
        }
    };

    const [selectedTestIndex, setSelectedTestIndex] = useState(null);

    // const handleSavePatientHistory = () => {
    //     if (selectedTestIndex == null) {
    //         toast.error("No test selected.");
    //         return;
    //     }

    //     // Validation
    //     for (let f of historyFields) {
    //         if (f.Is_Mandatory) {
    //             if (f.HistoryAttribute === "TextBox" && !f.HistoryValue?.trim()) {
    //                 toast.error(`${f.HistoryName} is mandatory.`);
    //                 return;
    //             }
    //             if (f.HistoryAttribute === "DateTime" && !f.HistoryValue) {
    //                 toast.error(`${f.HistoryName} is mandatory.`);
    //                 return;
    //             }
    //             if (f.HistoryAttribute === "Attachement") {
    //                 // Only require type/id after file is uploaded
    //                 if (!f.urnFilePath) {
    //                     toast.error(`Please upload a file for ${f.HistoryName}.`);
    //                     return;
    //                 }
    //                 if (!f.urnFileType) {
    //                     toast.error(`Document type is mandatory for ${f.HistoryName}.`);
    //                     return;
    //                 }
    //                 if (!f.urnOf) {
    //                     toast.error(`Document Of is mandatory for ${f.HistoryName}.`);
    //                     return;
    //                 }
    //                 if (!f.urnNumber?.trim()) {
    //                     toast.error(`Document ID is mandatory for ${f.HistoryName}.`);
    //                     return;
    //                 }
    //                 if (!validateDocNumber(f.urnFileType, f.urnNumber)) {
    //                     toast.error(`Invalid ${f.urnFileType} number.`);
    //                     return;
    //                 }
    //             }
    //         }
    //     }

    //     // Save into test
    //     const updatedTests = [...selectedTests];
    //     updatedTests[selectedTestIndex].HistoryAttribute = historyFields;

    //     //console.log("Saving history to test:", updatedTests[selectedTestIndex]);
    //     setSelectedTests(updatedTests);
    //     setShowTestHistoryModal(false);

    //     toast.success("Patient history saved.");
    // };

    const handleSavePatientHistory = () => {
        if (selectedTestIndex == null) {
            toast.error("No test selected.");
            return;
        }

        const updated = [...historyFields];

        for (let i = 0; i < updated.length; i++) {
            let f = updated[i];

            if (f.Is_Mandatory) {

                // Mandatory Check (Textbox / Dropdown / Datetime)
                if (!f.HistoryValue || f.HistoryValue.trim() === "") {
                    toast.error(`${f.HistoryName} is mandatory.`);
                    return;
                }

                // Attachment Only Validation Required
                if (f.HistoryAttribute === "Attachement") {

                    const attachments = f.HistoryAttachments || [];
                    const uploadedTypes = [...new Set(attachments.map(a => a.fileType))];

                    // When All options must be uploaded
                    if (f.Is_UploadAllAttachments) {

                        const missingOptions = f.Options.filter(opt => !uploadedTypes.includes(opt));

                        if (missingOptions.length > 0) {
                            toast.error(`${f.HistoryName} of ${missingOptions.join(", ")} is mandatory.`);
                            return;
                        }
                    }
                    // When only one attachment is enough
                    else {
                        if (attachments.length === 0) {
                            toast.error(`${f.HistoryName} is mandatory. Upload any one document.`);
                            return;
                        }
                    }
                }

            }
        }

        // Save to Selected Test Index
        const updatedTests = [...selectedTests];
        updatedTests[selectedTestIndex].HistoryAttribute = updated;
        setSelectedTests(updatedTests);

        toast.success("Patient history saved successfully.");
        setShowTestHistoryModal(false);
    };


    const [showTestWiseAttachmentModal, setShowTestWiseAttachmentModal] = useState(false);
    const [currentAttachmentIndex, setCurrentAttachmentIndex] = useState(null);
    const [selectedTestDocType, setSelectedTestDocType] = useState("");
    const [selectedTestFile, setSelectedTestFile] = useState(null);


    const [showTestHistoryModal, setShowTestHistoryModal] = useState(false);
    const [historyFields, setHistoryFields] = useState([]);

    const handleOpenTestAttachmentModal = (index) => {
        setCurrentAttachmentIndex(index);
        setSelectedTestDocType("");
        setSelectedTestFile(null);
        setShowTestWiseAttachmentModal(true);
    };

    const handleTestAttachmentClose = () => {
        setCurrentAttachmentIndex(null);
        setSelectedTestDocType("");
        setSelectedTestFile(null);
        setShowTestWiseAttachmentModal(false);
    };

    const handleTestWiseAttachFile = () => {
        if (selectedTestFile && selectedTestDocType && currentAttachmentIndex !== null) {

            //  validate file
            const { isValid, error } = validateFile(selectedTestFile);
            if (!isValid) {
                toast.error(error);
                return;
            }

            const formData = new FormData();
            formData.append('file', selectedTestFile);

            B2BRegistrationService.UploadAttachment(formData)
                .then(({ data }) => {
                    if (data.IsSuccess) {
                        setSelectedTests((prevTests) => {
                            const updatedTests = [...prevTests];
                            const currentTest = updatedTests[currentAttachmentIndex];

                            const existingAttachments = currentTest.TestAttachmentList || [];

                            const alreadyExists = existingAttachments.some(
                                (att) => att.type === selectedTestDocType
                            );

                            if (alreadyExists) {
                                toast.error(`Attachment of type "${selectedTestDocType}" already exists for this test.`);
                                return prevTests; // Return previous state without changes
                            }

                            const newAttachment = {
                                type: selectedTestDocType,
                                file: selectedTestFile.name,
                                file_url: data.Data
                            };

                            updatedTests[currentAttachmentIndex] = {
                                ...currentTest,
                                TestAttachmentList: [...existingAttachments, newAttachment]
                            };

                            toast.success("File attached to test.");
                            // handleTestAttachmentClose();

                            return updatedTests;
                        });
                    } else {
                        toast.error("Upload failed.");
                    }
                })
                .catch(() => toast.error("Something went wrong."));
        }
    };

    const handleDeleteAttachment = (attachmentIndex) => {
        setSelectedTests((prevTests) => {
            const updatedTests = [...prevTests];
            const currentTest = updatedTests[currentAttachmentIndex];
            const updatedAttachments = currentTest.TestAttachmentList.filter((_, i) => i !== attachmentIndex);
            updatedTests[currentAttachmentIndex] = {
                ...currentTest,
                TestAttachmentList: updatedAttachments
            };
            return updatedTests;
        });
        toast.success("Attachment deleted.");
    };


    const ValidateContainerBarcodeId = (container, barcodeId) => {

        B2BRegistrationService.ValidateContainerBarcodeId(container, barcodeId)
            .then(({ data }) => {
                if (data.IsSuccess) {

                } else {
                    toast.error(data.ResponseMessage);
                }
            })
            .catch(() => toast.error("Something went wrong."));
    };


    // const ValidateContainerBarcodeId = (container, barcodeId, index) => {
    //     // Check for duplicate barcode for same container
    //     const duplicate = selectedTests.some(
    //         (test, idx) =>
    //             idx !== index &&
    //             test.ContainerType === container &&
    //             test.BarcodeId === barcodeId
    //     );

    //     if (duplicate) {
    //         toast.error("Same container cannot have the same barcode again!");
    //         return;
    //     }

    //     // Proceed to API validation
    //     B2BRegistrationService.ValidateContainerBarcodeId(container, barcodeId)
    //         .then(({ data }) => {
    //             if (data.IsSuccess) {
    //                 // success logic (e.g. mark as valid)
    //             } else {
    //                 toast.error(data.ResponseMessage);
    //             }
    //         })
    //         .catch(() => toast.error("Something went wrong."));
    // };


    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const [photo, setPhoto] = useState(null);

    const [cameraModal, setCameraModel] = useState(false)

    // const handleCameraButtonClick = async () => {
    //     try {
    //         //debugger

    //         //Check if the browser supports camera access
    //         if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
    //             return;
    //         }

    //         //Query camera permission status (no prompt)
    //         const permissionStatus = await navigator.permissions.query({ name: "camera" });

    //         if (permissionStatus.state === "granted") {
    //             setCameraModel(true);
    //         } else if (permissionStatus.state === "denied") {
    //             alert("Camera access denied by user.");
    //         }

    //         // Optional: listen for permission changes
    //         // permissionStatus.onchange = () => {
    //         //     //console.log("Camera permission changed:", permissionStatus.state);
    //         // };
    //     } catch (err) {
    //         toast.error("Error checking camera access:", err);
    //     }
    // }

    const handleCameraButtonClick = async (index) => {
        // //debugger;
        // setTestIndex(index)
        try {
            setSelectedFile(null);

            // Ensure camera API support
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                toast.error("Camera not supported on this browser.");
                return;
            }

            // Directly request camera access (this triggers the popup)
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });

            // If the user allows access, show your camera modal
            setCameraModel(true);

            // (Optional) Close stream immediately if you only wanted permission
            stream.getTracks().forEach((track) => track.stop());
        } catch (err) {
            if (err.name === "NotAllowedError") {
                alert("Camera access was denied. Please allow access in browser settings and try again.");
            } else if (err.name === "NotFoundError") {
                toast.error("No camera device found.");
            } else {
                toast.error("Unable to access camera.");
            }
        }
    };

    const [testIndex, setTestIndex] = useState(null);

    const handleCameraModalClose = (file) => {
        //debugger;
        updateField({ selectedHistoryFile: file }, testIndex);
        setCameraModel(false);
    }

    // const openCamera = async () => {
    //     try {
    //         const stream = await navigator.mediaDevices.getUserMedia({ video: true });
    //         if (videoRef.current) {
    //             videoRef.current.srcObject = stream;
    //         }
    //     } catch (err) {
    //         console.error("Error accessing camera:", err);
    //         alert("Camera access denied or not available.");
    //     }
    // };

    // const takePhoto = () => {
    //     const context = canvasRef.current.getContext("2d");
    //     context.drawImage(videoRef.current, 0, 0, 320, 240);
    //     const imageData = canvasRef.current.toDataURL("image/png");
    //     setPhoto(imageData);
    // };

    const additionalInfo = watch("additionalInfo", "");
    const address1 = watch("address1", "");
    const address2 = watch("address2", "");
    const maxLengthForTextArea = 250

    const [salutationList, setSalutationList] = useState([]);

    // const getSalutationList = (e) => {
    //     //debugger;
    //     const selectedGender = e.target.value;

    //     if (selectedGender == 'Select Gender' || selectedGender == '') {
    //         setSalutationList([])
    //     }
    //     else {
    //         B2BRegistrationService.GetSalutationList(selectedGender)
    //             .then(({ data }) => {
    //                 if (data.IsSuccess) {
    //                     setSalutationList(data.Data)
    //                 } else {
    //                     setSalutationList([])
    //                 }
    //             })
    //             .catch(() => toast.error("Something went wrong."))
    //             .finally();
    //     }
    // };

    const salutationValue = watch("salutation");

    const getSalutationList = (e) => {
        const selectedGender = e.target.value;

        if (!selectedGender) {
            setSalutationList([]);
            setValue("salutation", ""); // reset
            return;
        }

        B2BRegistrationService.GetSalutationList(selectedGender)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    setSalutationList(data.Data);

                    const defaultSal = data.Data.find(x => x.IsDefault);
                    if (defaultSal) {
                        setValue("salutation", defaultSal.Salutation);
                    }
                } else {
                    setSalutationList([]);
                    setValue("salutation", "");
                }
            })
            .catch(() => toast.error("Something went wrong."));
    };

    const [testRemarkError, setTestRemarkError] = useState("");

    const handleTestRemarkChange = (value, idx) => {
        if (value.length > 200) {
            setTestRemarkError("Remarks cannot exceed 200 characters.");
        } else {
            setTestRemarkError("");
            const updatedTests = [...selectedTests];
            updatedTests[idx].Remarks = value;
            setSelectedTests(updatedTests);
        }
    };

    const updateField = (patch, index) => {
        const updated = [...historyFields];
        updated[index] = { ...updated[index], ...patch };
        setHistoryFields(updated);
        //console.log("updated", updated);
    };

    const handlePatientHistoryClose = () => {
        setSelectedFile(null);
        setShowTestHistoryModal(false);
        //console.log("selectedFile", selectedFile)
    }


    //barcode scanner
    const [showScanner, setShowScanner] = useState(false);
    const [activeIndex, setActiveIndex] = useState(null);


    const pincodeDataRef = useRef(null);
    const handlePincodeBlur = async () => {
        trigger("pincode");
        const pincode = getValues("pincode");

        const isValid = await trigger("pincode");
        if (!isValid) {
            setValue("PincodeAddress", "");
            return;
        }

        if (pincodeDataRef.current) {
            const { city, state, country } = pincodeDataRef.current;

            const formattedAddress = `${city} (${pincode}), ${state}, ${country}`;
            //console.log("Formatted PincodeAddress:", formattedAddress);

            setValue("PincodeAddress", formattedAddress);
        }
    };

    const getShortName = (first, last, limit = 20) => {
        const full = `${first || ""} ${last || ""}`.trim();
        if (!full) return "-";
        return full.length > limit ? full.substring(0, limit) + "..." : full;
    };

    const handleViewMoreClick = async () => {
        if (!validateLocationBeforeAction()) return;
        const isValid = await trigger(["salutation", "firstName", "gender", "dob", "age", "pincode"]);

        if (!isValid) {
            toast.error("Please enter mandatory fields.");
            return;
        }

        setSuggestionModel(true);
    }

    return (
        // <CommonContainer heading="B2B Registration" buttonText="">
        <div className="d-flex justify-content-center align-items-center min-vh-100 m-0 p-0">
            <Toaster position="top-center" reverseOrder={false} />
            <div className="card w-100 shadow-lg border-0 m-0 p-0" style={{ minHeight: "125vh" }}>
                <div className="card-body m-0">

                    <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mb-2 gap-2">
                        <div className="w-100 w-sm-auto d-flex gap-2 align-items-center">
                            <FaWpforms size={20} />
                            <h4 className="m-0 text-nowrap">Digital TRF Registration</h4>
                        </div>
                        <div className="d-flex flex-wrap justify-content-sm-end align-items-center gap-2 w-100 w-sm-auto">

                            <select ref={selectLocation} className="form-select form-select-b2b">
                                <option value="">Select Location</option>
                                {activeOrgLocationListData.map((item) => (
                                    <option key={item.OrgLocationId} value={item.OrgLocationId}>
                                        {item.OrgLocationName}
                                    </option>
                                ))}
                            </select>


                        </div>
                    </div>
                    {/* <button onClick={handleDownload}>
                        Download PDF
                    </button> */}

                    <div>
                        {/* <form onSubmit={handleSubmit(onSubmit)} autoComplete="off"> */}
                        <form onSubmit={handleSubmit(onSubmit)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") {
                                    e.preventDefault();
                                }
                            }} autoComplete="off">
                            {/* Patient Details */}
                            <div className="row digitalpatient-registration-wrapper">
                                {/* Patient Info Card */}
                                <div className="col-md-12 digitalpatient-card">
                                    <div className="card mb-3 custom-card-b2bregristration">
                                        <div className="card-header custom-card-heading text-white rounded-top-3 py-1" >
                                            <strong>Patient Information</strong>
                                        </div>
                                        <div className="card-body pb-2 pt-0 pl-2 pr-2">
                                            <input
                                                type="hidden"
                                                {...register("TRFID")}
                                                value={generateTRF(
                                                    userInfo?.Partner_Account_Details?.MHL_Client_Code__c,
                                                    parseInt(selectedOrg?.MHL_Org_Id__c)
                                                )}
                                            />
                                            <div className="row g-2 row-spacing-tight">

                                                {/* Gender */}
                                                <div className="col-12 col-sm-6 col-lg-2 mb-1">
                                                    <label className="required">Gender</label>
                                                    <select
                                                        className="form-select custom-sm-field"
                                                        {...register("gender", { required: "Gender is required" })}
                                                        onChange={getSalutationList}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="Female">Female</option>
                                                        <option value="Male">Male</option>
                                                        {/* <option value="Other">Other</option> */}
                                                        <option value="NA">NA</option>
                                                        <option value="Transgender">Transgender</option>
                                                        <option value="Veterinary">Veterinary</option>
                                                    </select>
                                                    {errors.gender && <p className="text-danger">{errors.gender.message}</p>}
                                                </div>

                                                {/* Salutation */}
                                                <div className="col-12 col-sm-6 col-lg-2 mb-1">
                                                    <label className="required">Salutation</label>
                                                    <select
                                                        className="form-select custom-sm-field"
                                                        // value={getValues("salutation") || ""}
                                                        value={salutationValue}

                                                        {...register("salutation", { required: "Salutation is required" })}
                                                        onChange={(e) => setValue("salutation", e.target.value)}
                                                    >
                                                        <option value="">Select</option>
                                                        {salutationList?.map((item, index) => (
                                                            <option key={index} value={item.Salutation}>
                                                                {item.Salutation}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors.salutation && <p className="text-danger">{errors.salutation.message}</p>}
                                                </div>

                                                {/* First Name */}
                                                <div className="col-12 col-sm-6 col-lg-3 mb-1">
                                                    <label className="required">First Name</label>
                                                    {/* <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter First Name"
                                                        {...register("firstName", {
                                                            required: "First Name is required",
                                                            maxLength: { value: 50, message: "50 characters max" },
                                                            pattern: { value: /^[a-zA-Z0-9]*$/, message: "Only letters and numbers" }
                                                        })}
                                                        onKeyDown={(e) => e.key === " " && e.preventDefault()}
                                                    />
                                                    {errors.firstName && <p className="text-danger">{errors.firstName.message}</p>}
                                                 */}
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter First Name"
                                                        {...register("firstName", {
                                                            required: "First Name is required",
                                                            maxLength: { value: 50, message: "Maximum 50 characters allowed" },
                                                            pattern: {
                                                                value: /^[a-zA-Z0-9]*$/,
                                                                message: "Only letters and numbers allowed",
                                                            },
                                                            onChange: (e) => {
                                                                const val = e.target.value.replace(/[^a-zA-Z0-9]/g, ""); // remove invalid chars and spaces
                                                                const formatted = val.charAt(0).toUpperCase() + val.slice(1);
                                                                setValue("firstName", formatted, { shouldValidate: true });
                                                            },
                                                        })}
                                                        onKeyDown={(e) => {
                                                            if (e.key === " ") e.preventDefault(); // block space input
                                                        }}
                                                    />
                                                    {errors.firstName && (
                                                        <p className="text-danger">{errors.firstName.message}</p>
                                                    )}
                                                </div>

                                                {/* Middle Name */}
                                                <div className="col-12 col-sm-6 col-lg-3 mb-1">
                                                    <label>Middle Name</label>
                                                    {/* <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Middle Name"
                                                        {...register("middleName")}
                                                        onKeyDown={(e) => e.key === " " && e.preventDefault()}
                                                    />
                                                    {errors.middleName && <p className="text-danger">{errors.middleName.message}</p>} */}
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Middle Name"
                                                        {...register("middleName", {
                                                            maxLength: { value: 50, message: "Maximum 50 characters allowed" },
                                                            pattern: {
                                                                value: /^[a-zA-Z]*$/,
                                                                message: "Only letters allowed",
                                                            },
                                                            onChange: (e) => {
                                                                const val = e.target.value.replace(/[^a-zA-Z]/g, "");
                                                                const formatted = val.charAt(0).toUpperCase() + val.slice(1);
                                                                setValue("middleName", formatted, { shouldValidate: true });
                                                            },
                                                        })}
                                                        onKeyDown={(e) => {
                                                            if (e.key === " ") e.preventDefault();
                                                        }}
                                                    />
                                                    {errors.middleName && (
                                                        <p className="text-danger">{errors.middleName.message}</p>
                                                    )}
                                                </div>

                                                {/* Last Name */}
                                                <div className="col-12 col-sm-6 col-lg-2 mb-1">
                                                    <label>Last Name</label>
                                                    {/* <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Last Name"
                                                        {...register("lastName", {
                                                            maxLength: { value: 50, message: "Maximum 50 characters allowed" },
                                                            pattern: {
                                                                value: /^[a-zA-Z0-9]*$/,
                                                                message: "Only letters and numbers allowed",
                                                            },
                                                            onChange: (e) => {
                                                                const val = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                                                                const formatted = val.charAt(0).toUpperCase() + val.slice(1);
                                                                setValue("lastName", formatted, { shouldValidate: true });
                                                            },
                                                        })}
                                                        onKeyDown={(e) => {
                                                            if (e.key === " ") e.preventDefault();
                                                        }}
                                                    />
                                                    {errors.lastName && (
                                                        <p className="text-danger">{errors.lastName.message}</p>
                                                    )} </div> */}
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Last Name"
                                                        {...register("lastName", {
                                                            maxLength: { value: 50, message: "Maximum 50 characters allowed" },
                                                            pattern: {
                                                                value: /^[a-zA-Z0-9]*$/,
                                                                message: "Only letters and numbers allowed",
                                                            },
                                                            onChange: (e) => {
                                                                const val = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                                                                const formatted = val.charAt(0).toUpperCase() + val.slice(1);
                                                                setValue("lastName", formatted, { shouldValidate: true });
                                                            },
                                                        })}
                                                        onKeyDown={(e) => {
                                                            if (e.key === " ") e.preventDefault();
                                                        }}
                                                    />
                                                    {errors.lastName && (
                                                        <p className="text-danger">{errors.lastName.message}</p>
                                                    )}
                                                </div>
                                            </div>


                                            <div className="row g-2 row-spacing-tight">

                                                <div className="col-12 col-sm-6 col-lg-2">
                                                    <label className="required">Age</label>
                                                    <div className="input-group">
                                                        <input
                                                            type="number"
                                                            step={ageUnit === "Year" ? "0.01" : "1"}
                                                            min="0"
                                                            className="form-control"
                                                            style={{ flex: "0 0 45%" }}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "e" || e.key === "E" || e.key === "+" || e.key === "-") {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                            value={ageValue}
                                                            onChange={(e) => {
                                                                let val = e.target.value;
                                                                if (!/^(\d+(\.\d{0,2})?)?$/.test(val)) return;
                                                                // Prevent negative
                                                                if (val < 0) return;

                                                                // Validation by unit
                                                                if (ageUnit === "Year") {
                                                                    // Only allow up to 150.11 (years and months)
                                                                    let [years, decimals] = val.split(".");
                                                                    years = years.replace(/^0+/, ""); // Remove leading zeros
                                                                    if (!years) years = "0";
                                                                    if (parseInt(years) > 125) years = "125";
                                                                    if (decimals && decimals.length > 2) decimals = decimals.slice(0, 2);
                                                                    // Only allow decimals 00 to 11 (months)
                                                                    if (decimals && parseInt(decimals) > 11) decimals = "11";
                                                                    if (decimals !== undefined) val = `${years}.${decimals}`; else val = years;
                                                                    // Prevent 150.12 or higher
                                                                    if (parseInt(years) === 150 && decimals && parseInt(decimals) > 0) val = "150.00";
                                                                } else if (ageUnit === "Month") {
                                                                    if (parseInt(val) > 12) val = "12";
                                                                } else if (ageUnit === "Week") {
                                                                    if (parseInt(val) > 4) val = "4";
                                                                } else if (ageUnit === "Day") {
                                                                    if (parseInt(val) > 7) val = "7";
                                                                }

                                                                // Remove decimals for non-year units
                                                                if (["Month", "Day", "Week"].includes(ageUnit)) {
                                                                    val = val.split(".")[0];
                                                                }

                                                                setAgeValue(val);
                                                                calculateDOBFromAge(val, ageUnit);
                                                                setValue("age", val);
                                                            }}
                                                            placeholder="Enter"
                                                        />
                                                        <select
                                                            className="form-select"
                                                            style={{
                                                                flex: "0 0 55%",
                                                                padding: "0 3px 3px 8px"
                                                            }}
                                                            value={ageUnit}
                                                            onChange={(e) => {
                                                                const newUnit = e.target.value;
                                                                setAgeUnit(newUnit);
                                                                // Reset age value on unit change
                                                                let newVal = "";
                                                                if (newUnit === "Year") newVal = "0";
                                                                else if (newUnit === "Month") newVal = "1";
                                                                else if (newUnit === "Week") newVal = "1";
                                                                else if (newUnit === "Day") newVal = "1";
                                                                setAgeValue(newVal);
                                                                calculateDOBFromAge(newVal, newUnit);
                                                                setValue("age", newVal);
                                                            }}
                                                        >
                                                            <option value="Year">Year(s)</option>
                                                            <option value="Month">Month(s)</option>
                                                            <option value="Week">Week(s)</option>
                                                            <option value="Day">Day(s)</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-sm-6 col-lg-2">
                                                    <label className="required">DOB</label>
                                                    <div style={{ position: 'relative', minHeight: 40 }} className="custom-sm-field  position-relative">
                                                        <DatePicker
                                                            className="form-control"
                                                            {...register("dob", { required: "DOB is required" })}
                                                            selected={dob}
                                                            onChange={(date) => {
                                                                if (date < MIN_DOB) {
                                                                    date = MIN_DOB;
                                                                }
                                                                setDob(date);
                                                                calculateAgeFromDOB(date);
                                                                setValue("dob", date);
                                                            }}
                                                            dateFormat="dd/MM/yyyy"
                                                            minDate={MIN_DOB}
                                                            maxDate={new Date()}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            ref={startDateRef}
                                                            placeholderText="DD/MM/YYYY"
                                                        />
                                                        <Calendar
                                                            size={20}
                                                            style={{
                                                                position: 'absolute',
                                                                right: '12px',
                                                                top: '45%',
                                                                transform: 'translateY(-50%)',
                                                                cursor: 'pointer',
                                                                pointerEvents: 'auto',
                                                            }}
                                                            onClick={() => startDateRef.current.setFocus()}
                                                        />
                                                    </div>
                                                    <div >
                                                        {errors.dob && <p className="text-danger mb-0">{errors.dob.message}</p>}
                                                    </div>

                                                </div>
                                                <input type="hidden" {...register("patientAge")} />

                                                <div className="col-12 col-sm-6 col-lg-2 mb-1">
                                                    <label>Mobile Number</label>
                                                    <div className="input-group align-items-stretch">
                                                        <span
                                                            className="input-group-text d-flex align-items-center"
                                                            style={{
                                                                backgroundColor: "#f8f9fa",
                                                                fontWeight: 500,
                                                                borderRight: "none",
                                                                borderTopRightRadius: 0,
                                                                borderBottomRightRadius: 0,
                                                                padding: "0.375rem 0.75rem", // match Bootstrap default input padding
                                                                height: "38px", // ensures equal height with input
                                                                fontSize: "14px"
                                                            }}
                                                        >
                                                            +91
                                                        </span>
                                                        <input
                                                            type="text"
                                                            className="form-control custom-sm-field"
                                                            placeholder="Enter Mobile Num"
                                                            maxLength={10}
                                                            style={{
                                                                borderLeft: "none",
                                                                borderTopLeftRadius: 0,
                                                                borderBottomLeftRadius: 0,
                                                                height: "38px", // match with +91 box
                                                            }}
                                                            {...register("mobile", {
                                                                validate: (value) => {
                                                                    if (!value) return true; // allow empty if not required

                                                                    // Must be exactly 10 digits
                                                                    if (!/^\d{10}$/.test(value)) {
                                                                        return "Mobile number must be exactly 10 digits";
                                                                    }

                                                                    // Must start with 6–9
                                                                    if (!/^[6-9]/.test(value)) {
                                                                        return "Mobile number must start with 6, 7, 8, or 9";
                                                                    }

                                                                    // Block 7 or more consecutive same digits (except 9999999999)
                                                                    if (value !== "9999999999" && /(\d)\1{6,}/.test(value)) {
                                                                        return "Invalid mobile number (digit repeated 7+ times consecutively)";
                                                                    }

                                                                    return true; //  valid number
                                                                },
                                                            })}
                                                            onInput={(e) => {
                                                                // allow only digits while typing
                                                                e.target.value = e.target.value.replace(/\D/g, "");
                                                            }}
                                                        />


                                                    </div>
                                                    {errors.mobile && (
                                                        <p className="text-danger mb-0">{errors.mobile.message}</p>
                                                    )}
                                                </div>

                                                <div className="col-12 col-sm-6 col-lg-2 mb-1">
                                                    <label>Ref. Doctor Name</label>
                                                    <input type="text" className="form-control" placeholder="Enter Doctor Name" autoComplete="on" {...register("doctorName", {
                                                        onChange: (e) => {
                                                            const val = e.target.value;
                                                            const capitalized = val.charAt(0).toUpperCase() + val.slice(1);
                                                            setValue("doctorName", capitalized, { shouldValidate: true });
                                                        }
                                                    })} />
                                                </div>

                                                <input type="hidden" {...register("PincodeAddress")} />

                                                {/* <div className="col-md-6 col-xl-4 mb-1"> */}
                                                <div className="col-12 col-sm-6 col-lg-2 mb-1">
                                                    <label className="required">Pincode</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        maxLength={6}
                                                        placeholder="Enter 6-digit Pincode"
                                                        {...register("pincode", {
                                                            required: "Pincode is required",
                                                            validate: async (value) => {
                                                                if (!value) return true;

                                                                if (value.length !== 6) return "Pincode must be 6 digits";

                                                                try {
                                                                    const { data } = await B2BRegistrationService.GetPincodeStateDetails(value);
                                                                    //console.log("API Response:", data.Data);

                                                                    if (data?.IsSuccess) {
                                                                        pincodeDataRef.current = data.Data; // ✅ store API data for reuse
                                                                        return true;
                                                                    }

                                                                    pincodeDataRef.current = null;
                                                                    return "Invalid Pincode";
                                                                } catch {
                                                                    pincodeDataRef.current = null;
                                                                    return "Invalid Pincode";
                                                                }
                                                            },
                                                            pattern: { value: /^[0-9]*$/, message: "Only numbers allowed" },
                                                        })}
                                                        onInput={(e) => (e.target.value = e.target.value.replace(/\D/g, ""))}
                                                        onBlur={handlePincodeBlur}
                                                        defaultValue={userDetails?.Pincode ? userDetails?.Pincode : ""}
                                                    />
                                                    {errors.pincode && (
                                                        <small className="text-danger">{errors.pincode.message}&nbsp;</small>
                                                    )}
                                                </div>
                                                <div className="col-12 col-sm-6 col-lg-2 d-flex align-items-end justify-content-end mb-2">
                                                    <button
                                                        type="button"
                                                        className="btn custom-sumbitbtn d-flex justify-content-center align-items-center"
                                                        title="Add Patient Documents"
                                                        onClick={() => setShowAttachDocumentModal(true)}
                                                        // style={{ height: "35px" }}
                                                    >
                                                        <FaPlus size={11} style={{ marginRight: "2px" }} />
                                                        Patient Documents
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="row" style={{ display: "none" }}>

                                                {/* 
                                                <div className="col-md-6 col-xl-4 mb-1">
                                                    <label>Mobile Number</label>
                                                    <div className="input-group align-items-stretch">
                                                        <span
                                                            className="input-group-text d-flex align-items-center"
                                                            style={{
                                                                backgroundColor: "#f8f9fa",
                                                                fontWeight: 500,
                                                                borderRight: "none",
                                                                borderTopRightRadius: 0,
                                                                borderBottomRightRadius: 0,
                                                                padding: "0.375rem 0.75rem", 
                                                                height: "38px", 
                                                                fontSize: "14px"
                                                            }}
                                                        >
                                                            +91
                                                        </span>
                                                        <input
                                                            type="text"
                                                            className="form-control custom-sm-field"
                                                            placeholder="Enter Mobile Number"
                                                            maxLength={10}
                                                            style={{
                                                                borderLeft: "none",
                                                                borderTopLeftRadius: 0,
                                                                borderBottomLeftRadius: 0,
                                                                height: "38px", 
                                                            }}
                                                            {...register("mobile", {
                                                                validate: (value) => {
                                                                    if (!value) return true; 

                                                                    if (!/^\d{10}$/.test(value)) {
                                                                        return "Mobile number must be exactly 10 digits";
                                                                    }

                                                                    if (!/^[6-9]/.test(value)) {
                                                                        return "Mobile number must start with 6, 7, 8, or 9";
                                                                    }

                                                                    if (value !== "9999999999" && /(\d)\1{6,}/.test(value)) {
                                                                        return "Invalid mobile number (digit repeated 7+ times consecutively)";
                                                                    }

                                                                    return true;                                                                 },
                                                            })}
                                                            onInput={(e) => {
                                                                
                                                                e.target.value = e.target.value.replace(/\D/g, "");
                                                            }}
                                                        />


                                                    </div>
                                                    {errors.mobile && (
                                                        <p className="text-danger mb-0">{errors.mobile.message}</p>
                                                    )}
                                                </div> */}



                                                <div className="col-md-6 col-xl-4 mb-1">
                                                    <label>Email</label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        placeholder="Enter Email"
                                                        {...register("email", {
                                                            maxLength: { value: 50, message: "Max 50 chars" },
                                                            validate: (value) => {
                                                                if (!value) return true;
                                                                return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || "Invalid email";
                                                            },
                                                        })}
                                                    />
                                                    {errors.email && <p className="text-danger">{errors.email.message}</p>}
                                                </div>

                                                <div className="col-md-12 col-xl-4 mb-1">
                                                    <label>Ref. Doctor Name</label>
                                                    <input type="text" className="form-control" placeholder="Enter Doctor Name (e.g., Dr. Name)" autoComplete="on" {...register("doctorName", {
                                                        onChange: (e) => {
                                                            const val = e.target.value;
                                                            const capitalized = val.charAt(0).toUpperCase() + val.slice(1);
                                                            setValue("doctorName", capitalized, { shouldValidate: true });
                                                        }
                                                    })} />
                                                </div>
                                            </div>
                                            {/* <div className="row">
                                                <div className="col d-flex justify-content-end mt-1">
                                                    <button
                                                        title="Add Patient Documents"
                                                        type="button"
                                                        className="btn custom-sumbitbtn d-flex align-items-center gap-1"
                                                        onClick={() => setShowAttachDocumentModal(true)}
                                                    >
                                                        <FaPlus size={14} />
                                                        Patient Documents
                                                    </button>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>

                                {/* Address Info Card */}
                                <div className="col-md-4 digitalpatient-card" style={{ display: "none" }}>
                                    <div className="card mb-3 custom-card-b2bregristration">
                                        <div className="card-header custom-card-heading text-white rounded-top-3 py-1">
                                            <strong>Address</strong>
                                        </div>
                                        <div className="card-body pt-0 pl-2 pr-2">
                                            {/* <div className="mb-2 pr-1">
                                                <label className="required">Pincode</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    maxLength={6}
                                                    placeholder="Enter 6-digit Pincode"
                                                    {...register("pincode", {
                                                        required: "Pincode is required",
                                                        validate: async (value) => {
                                                            if (!value) return true;

                                                            if (value.length !== 6) return "Pincode must be 6 digits";

                                                            try {
                                                                const { data } = await B2BRegistrationService.GetPincodeStateDetails(value);
                                                                return data.IsSuccess || "Invalid Pincode";
                                                            } catch {
                                                                return "Invalid Pincode";
                                                            }
                                                        },
                                                        pattern: { value: /^[0-9]*$/, message: "Only numbers allowed" },
                                                    })}
                                                    onInput={(e) => (e.target.value = e.target.value.replace(/\D/g, ""))}
                                                    onBlur={() => trigger("pincode")} // validate only on blur
                                                />
                                                {errors.pincode && (
                                                    <small className="text-danger">{errors.pincode.message}&nbsp;</small>
                                                )}
                                            </div> */}
                                            <div className="mb-2 pr-1">
                                                <div className="d-flex align-items-end justify-content-between">
                                                    <label className="mb-1">Address Line 1</label>
                                                    <small style={{ fontSize: "13px", fontWeight: "500" }}>
                                                        {address1.length}/{maxLengthForTextArea}
                                                    </small>
                                                </div>
                                                <textarea
                                                    className="form-control"
                                                    placeholder="Enter Floor, Building, Street, Area"
                                                    rows="2"
                                                    {...register("address1", { maxLength: { value: maxLengthForTextArea, message: "Max 250 char" } })}
                                                />
                                                <div className="d-flex justify-content-between">
                                                    {errors.address1 && (
                                                        <small className="text-danger">{errors.address1.message}</small>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="mb-2 pr-1">
                                                {/* <div className="mb-1 pr-1"> */}
                                                <div className="d-flex align-items-end justify-content-between">
                                                    <label className="mb-1">Address Line 2</label>
                                                    <small style={{ fontSize: "13px", fontWeight: "500" }}>
                                                        {address2.length}/{maxLengthForTextArea}
                                                    </small>
                                                </div>
                                                {/* </div> */}
                                                <textarea
                                                    className="form-control"
                                                    placeholder="Enter City (East/West), State, Country, Landmark"
                                                    rows="2"
                                                    {...register("address2", { maxLength: { value: maxLengthForTextArea, message: "Max 250 chars" } })}
                                                />
                                                <div className="d-flex justify-content-between">
                                                    {errors.address2 && (
                                                        <small className="text-danger">{errors.address2.message}</small>
                                                    )}
                                                </div>
                                            </div>
                                            {/* <div className="mb-1 pr-1">
                                                <label>Pincode</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    maxLength={6}
                                                    placeholder="Enter 6-digit Pincode"
                                                    {...register("pincode", {
                                                        pattern: { value: /^[0-9]*$/, message: "Only numbers allowed" },
                                                    })}
                                                    onInput={(e) => (e.target.value = e.target.value.replace(/\D/g, ""))}
                                                />
                                                {errors.pincode && <small className="text-danger">{errors.pincode.message}</small>}
                                            </div> */}

                                        </div>
                                    </div>
                                </div>
                            </div>


                            {/* Test Search Section */}
                            <div className="border p-2" ref={testsSectionRef}>
                                {/* <div className="row align-items-start mb-2"></div> */}
                                {/* <h6><b>Tests:</b></h6> */}

                                <div className="row px-1">
                                    <div className="col-lg-4 col-12 mb-2 px-2">
                                        <h6><b>Tests:</b></h6>

                                        <div className="position-relative custom-test-search" ref={searchRef}>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search by Test Name, Code"
                                                ref={selectedSearchTestName}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        e.preventDefault();
                                                        fetchRateCard();
                                                    }
                                                    if (e.key === "Backspace") {
                                                        const nextValue = e.currentTarget.value.slice(0, -1);
                                                        if (!nextValue.trim()) setTestCodeSearchData([]);
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    const value = e.target.value
                                                        .toUpperCase()
                                                        .replace(/[^A-Z0-9_\s]/g, "");
                                                    e.target.value = value;
                                                    value ? setShowDropdown(true) : setTestCodeSearchData([]);
                                                    setSearchTestText(value);
                                                }}
                                                style={{ paddingRight: "40px" }}
                                            />

                                            {(showDropdown && testCodeSearchData.length > 0) && (
                                                <ul
                                                    className="list-group position-absolute w-100"
                                                    style={{
                                                        zIndex: 1000,
                                                        maxHeight: "180px",
                                                        overflowY: "auto",
                                                        fontSize: "11px"
                                                    }}
                                                >
                                                    {testCodeSearchData.map((item) => (
                                                        <li
                                                            key={item.TestCode}
                                                            className="list-group-item d-flex justify-content-between align-items-center p-1"
                                                        >
                                                            <span>
                                                                {item.TestName} (<b>{item.TestCode}</b>)
                                                            </span>
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm custom-add-btn"
                                                                onClick={() => handleAddTest(item)}
                                                            >
                                                                <i className="fas fa-plus"></i>
                                                            </button>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}

                                            <button
                                                type="button"
                                                className="btn custom-sumbitbtn position-absolute d-flex align-items-center justify-content-center"
                                                style={{ padding: "5px", right: "0", height: "35px", width: "40px", top: "50%", fontSize: "14px", borderTopLeftRadius: "0", borderBottomLeftRadius: "0", transform: "translateY(-50%)" }}
                                                onClick={fetchRateCard}
                                            >
                                                {SearchLoading ? <FaSpinner className="fa-spin" /> : <FaSearch />}
                                            </button>
                                        </div>
                                    </div>

                                    {/* Frequently Booked Tests */}
                                    {testSuggestions.length > 0 && (
                                        <div className="col-lg-8 col-12 mb-2 px-2">
                                            <h6 className="mb-2">
                                                <b>Frequently Booked Tests:</b>
                                            </h6>

                                        <div className="d-flex flex-column flex-sm-row gap-2 justify-content-between align-items-end align-items-sm-center">
                                            <div
                                                className="d-flex gap-2 flex-nowrap flex-grow-1"
                                                style={{
                                                    minWidth: 0,
                                                    width: "100%",
                                                    overflowX: "auto",
                                                    overflowY: "hidden",
                                                    WebkitOverflowScrolling: "touch"
                                                }}
                                            >
                                                {testSuggestions.slice(0, 4).map((rec) => {
                                                    const isAdded = selectedTests.some(
                                                        (t) => t.TestCode === rec.TestCode
                                                    );

                                                    const isLoading =
                                                        suggestionButtonLoading && loadingItem === rec.Id;

                                                    return (
                                                        <button
                                                            key={rec.Id}
                                                            type="button"
                                                            disabled={isAdded || (suggestionButtonLoading && loadingItem !== null)}
                                                            className={`btn suggestion-btn flex-shrink-0 ${
                                                                isAdded ? "suggestion-selected" : ""
                                                            }`}
                                                            style={{
                                                                fontSize: "11.5px",
                                                                minWidth: "140px",
                                                                paddingLeft: "1px",
                                                                paddingRight: "1px"
                                                            }}
                                                            onClick={() => handleAddTestFromSuggestion(rec)}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Enter" && !isAdded && !isLoading) {
                                                                    e.preventDefault();
                                                                    handleAddTestFromSuggestion(rec);
                                                                }
                                                            }}
                                                            title={`${rec.TestName} (${rec.TestCode})`}
                                                        >
                                                            {isLoading ? (
                                                                <FaSpinner className="fa-spin" />
                                                            ) : (
                                                                getShortName(rec.TestName)
                                                            )}
                                                        </button>
                                                    );
                                                })}
                                            </div>

                                                <button
                                                    type="button"
                                                    className="btn btn-lg custom-sumbitbtn py-2"
                                                    style={{ fontSize: "14px", width: "120px" }}
                                                    onClick={handleViewMoreClick}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            e.preventDefault();
                                                            handleViewMoreClick();
                                                        }
                                                    }}
                                                    title="View more frequently booked tests"
                                                >
                                                    View More
                                                </button>
                                            </div>
                                        </div>
                                    )}



                                    {/* <div className="col-md-4 col-12 mt-2 mb-1">
                                        <button className="btn btn-success" type="button" onClick={() => { setShowTestHistoryModal(true); }}>Add History</button>
                                    </div> */}


                                </div>

                                {/* TABLE SECTION */}
                                <div className="table-responsive">
                                    <table className="table table-bordered custom-table">
                                        <thead>
                                            <tr>
                                                <th>Test Name(Code)</th>
                                                <th>
                                                    Estimated TAT
                                                    {/* <i className="fas fa-info-circle text-muted ml-1" title="Have not calculated logistic"></i> */}
                                                </th>
                                                <th>Processing Location</th>
                                                <th>Test Remarks</th>
                                                <th style={{ width: '13%' }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedTests.length > 0 ? (
                                                selectedTests.map((test, idx) => (
                                                    <React.Fragment key={idx}>
                                                        <tr className="b2b-test-list-row">
                                                            <td className="text-left align-middle" style={{ width: '30%', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                                                {/* {test.f?.length > 0 ? (
                                                                        <button
                                                                            title="Click To Expand"
                                                                            type="button"
                                                                            className={`btn btn-sm ml-1`}
                                                                            style={{ padding: "0.25rem 0.5rem", fontWeight: "bold" }}
                                                                            onClick={() => {
                                                                                const updatedTests = [...selectedTests];
                                                                                updatedTests[idx].isExpanded = !updatedTests[idx].isExpanded;
                                                                                setSelectedTests(updatedTests);
                                                                            }}
                                                                        >
                                                                            {test.isExpanded ? "▼" : "▶"}
                                                                        </button>
                                                                    ) : <>&nbsp;</>} */}
                                                                {!test.IsManualTest && (
                                                                    <>
                                                                        &nbsp;
                                                                        {test.TestName} (<b>{test.TestCode}</b>)

                                                                        {test.PackageTestConfigList?.length > 0 &&
                                                                            (<i className="fas fa-info-circle text-muted ml-1" title="Click to View Container" onClick={() => handleContainerClick(test)}></i>)
                                                                        }

                                                                    </>
                                                                )}
                                                            </td>

                                                            {/* <td>{formatVisitDate(test.TestTat)}</td> */}
                                                            <td>{test.ReportTATISO}</td>
                                                            <td>
                                                                {test.ProcessingLocation && (
                                                                    <>
                                                                        {test.ProcessingLocation.includes(",") ? (
                                                                            <Popover
                                                                                content={
                                                                                    <ul
                                                                                        className="list-unstyled"
                                                                                        style={{ textAlign: "left", paddingLeft: "2px", margin: 0 }}
                                                                                    >
                                                                                        {test.ProcessingLocation.split(",").map((loc, index) => (
                                                                                            <li key={index}>{loc.trim()}</li>
                                                                                        ))}
                                                                                    </ul>
                                                                                }
                                                                            >
                                                                                <span style={{ cursor: "pointer" }}>
                                                                                    {test.ProcessingLocation.split(",")[0]}{" "}
                                                                                    (+{test.ProcessingLocation.split(",").length - 1})
                                                                                </span>
                                                                            </Popover>
                                                                        ) : (
                                                                            test.ProcessingLocation
                                                                        )}
                                                                    </>
                                                                )}


                                                            </td>
                                                            {/* <td style={{ minWidth: '150px' }}>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-primary"
                                                                        title="View Container Info"
                                                                        onClick={() => handleContainerClick(test)}
                                                                    >
                                                                        View Container
                                                                    </button>
                                                                </td> */}

                                                            {/* <td style={{ padding: "3px" }}>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={test.Remarks || ""}
                                                                        onChange={(e) => {
                                                                            const updatedTests = [...selectedTests];
                                                                            updatedTests[idx].Remarks = e.target.value;
                                                                            setSelectedTests(updatedTests);
                                                                        }}
                                                                        placeholder="Enter Test Remarks"
                                                                        maxLength={200} // restrict to 200 characters
                                                                    />
                                                                </td> */}
                                                            <td style={{ padding: "3px" }}>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={test.Remarks || ""}
                                                                    onChange={(e) => handleTestRemarkChange(e.target.value, idx)}
                                                                    placeholder="Enter Test Remarks"
                                                                />
                                                                {testRemarkError && (
                                                                    <div style={{ color: "red", fontSize: "0.8em" }}>{testRemarkError}</div>
                                                                )}
                                                            </td>

                                                            {/* <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                                    <div className="d-flex justify-content-center align-items-center gap-2">
                                                                        <div className="d-flex gap-2 align-items-center justify-content-center">
                                                                            {test.IsHistory && (
                                                                                <button
                                                                                    type="button"
                                                                                    className="mr-2 cursor-pointer btn btn-sm custom-sumbitbtn d-flex align-items-center gap-1"
                                                                                    onClick={() => handleHistory(idx)}
                                                                                    title="Add Patient History"
                                                                                    ref={(el) => (docsButtonRefs.current[idx] = el)}
                                                                                >
                                                                                    <FaPlus />
                                                                                    Docs
                                                                                </button>
                                                                            )}

                                                                            {!test.IsHistory && (
                                                                                <button style={{ visibility: 'hidden' }} className="mr-2 cursor-pointer btn btn-sm custom-sumbitbtn d-flex align-items-center gap-1">
                                                                                    <FaPlus />
                                                                                    Docs
                                                                                </button>
                                                                            )}

                                                                            <FaTrash
                                                                                color="red"
                                                                                style={{ cursor: "pointer" }}
                                                                                onClick={() => handleDeleteTest(idx)}
                                                                                title="Delete Test"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </td> */}
                                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                                <div className="d-flex justify-content-center align-items-center gap-2">
                                                                    {hasAnyHistory ? (
                                                                        // Case 1: At least one test has history
                                                                        <div className="d-flex gap-2 align-items-center justify-content-center">
                                                                            {test.IsHistory ? (
                                                                                <button
                                                                                    type="button"
                                                                                    className="mr-2 cursor-pointer btn btn-sm custom-sumbitbtn d-flex align-items-center gap-1"
                                                                                    onClick={() => handleHistory(idx)}
                                                                                    title="Add Patient History"
                                                                                    ref={(el) => (docsButtonRefs.current[idx] = el)}
                                                                                >
                                                                                    <FaPlus />
                                                                                    Docs
                                                                                </button>
                                                                            ) : (
                                                                                // Invisible placeholder for alignment
                                                                                <button
                                                                                    style={{ visibility: 'hidden' }}
                                                                                    className="mr-2 cursor-pointer btn btn-sm custom-sumbitbtn d-flex align-items-center gap-1"
                                                                                >
                                                                                    <FaPlus />
                                                                                    Docs
                                                                                </button>
                                                                            )}

                                                                            <FaTrash
                                                                                color="red"
                                                                                style={{ cursor: "pointer" }}
                                                                                onClick={() => handleDeleteTest(idx)}
                                                                                title="Delete Test"
                                                                            />
                                                                        </div>
                                                                    ) : (
                                                                        // Case 2: No tests have history — only show centered trash
                                                                        <FaTrash
                                                                            color="red"
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => handleDeleteTest(idx)}
                                                                            title="Delete Test"
                                                                        />
                                                                    )}
                                                                </div>
                                                            </td>

                                                        </tr>

                                                        {/* Expanded row */}
                                                        {
                                                            test.isExpanded && test.PackageTestConfigList?.length > 0 && (
                                                                <tr>
                                                                    <td colSpan={5} className="p-0">
                                                                        <table className="table table-bordered custom-table mb-0">
                                                                            <thead className="bg-success">
                                                                                <tr>
                                                                                    {/* <th style={{ width: '35%', whiteSpace: 'normal', wordBreak: 'break-word' }}>Test Code(s)</th> */}
                                                                                    <th style={{ width: '35%', whiteSpace: 'normal', wordBreak: 'break-word' }}>Test Name</th>
                                                                                    <th style={{ width: '15%', whiteSpace: 'normal', wordBreak: 'break-word' }}>Container</th>
                                                                                    <th style={{ width: '25%', whiteSpace: 'normal', wordBreak: 'break-word' }}>Sample</th>
                                                                                    <th style={{ width: '25%', whiteSpace: 'normal', wordBreak: 'break-word' }}>Remark</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {test.PackageTestConfigList.map((item, subIdx) => (
                                                                                    <tr key={subIdx}>
                                                                                        <td style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>{item.TestName}</td>
                                                                                        <td style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>{item.ContainerName || '-'}</td>
                                                                                        <td style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>{item.SampleName || '-'}</td>
                                                                                        <td style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                                                                            <input
                                                                                                type="text"
                                                                                                className="form-control"
                                                                                                value={item.Remark || ""}
                                                                                                onChange={(e) => {
                                                                                                    const updatedTests = [...selectedTests];
                                                                                                    updatedTests[idx].PackageTestConfigList[subIdx] = {
                                                                                                        ...item,
                                                                                                        Remark: e.target.value,
                                                                                                    };
                                                                                                    setSelectedTests(updatedTests);
                                                                                                }}
                                                                                                placeholder="Enter BarcodeId"
                                                                                            />
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }

                                                    </React.Fragment>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" className="text-center">No Test Added</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Sample & Container Info Details  */}
                                <>
                                    <div className="row mb-2">
                                        {/* Left: Title */}
                                        <div className="col-12 col-md-6 d-flex align-items-center mb-2 mb-md-0">
                                            <h6 className="mb-0">
                                                <b>Sample & Container Info:</b>
                                            </h6>
                                        </div>

                                        {/* Right: DateTime */}
                                        <div className="col-12 col-md-6 d-flex flex-column flex-sm-row align-items-sm-center ms-auto justify-content-end">
                                            <div>
                                                <label className="mr-2 mb-0">
                                                    Sample Collection Date/Time:
                                                </label>
                                                {/* <input
                                                type="datetime-local"
                                                className="form-control"
                                                style={{ maxWidth: "220px" }}
                                                value={sampleCollectionDateTime}
                                                max={getTodayMaxDateTime()}
                                                onChange={(e) => setSampleCollectionDateTime(e.target.value)}
                                            /> */}
                                                <input
                                                    type="datetime-local"
                                                    className="form-control"
                                                    style={{ maxWidth: "220px" }}
                                                    value={sampleCollectionDateTime}
                                                    min={getMinDateTime()}
                                                    max={getTodayMaxDateTime()}
                                                    onChange={handleTyping}
                                                    onBlur={handleValidate}
                                                />
                                            </div>

                                        </div>

                                    </div>

                                    {/* Summary Header */}
                                    <div className="p-2 bg-light border rounded" style={{ fontSize: "13px" }}>
                                        <strong>Total Containers Count: {totalContainers}</strong>
                                        {Object.entries(containerAggregation).filter(([name]) => name !== "NO CONTAINER").map(([name, count], idx) => (
                                            <span key={idx} className="ml-3">
                                                <b>{name}</b>: {count}
                                            </span>
                                        ))}
                                    </div>

                                    {/* Sample & Container Info Table */}
                                    <div className="table-responsive mt-2">
                                        <table className="table table-bordered custom-table">
                                            <thead>
                                                <tr>
                                                    <th>Tests</th>
                                                    {/* <th>Container Type</th> */}
                                                    <th>Container Type / Sample</th>
                                                    <th>No. of Vials</th>
                                                    {/* <th>Sample</th> */}
                                                    <th>Processing Location</th>
                                                    {userDetails?.Is_Avail_For_PrePrintedBarcode && (
                                                        <th>
                                                            Pre-printed<br /> Barcode
                                                        </th>
                                                    )}
                                                    {/* <th>Remark</th>
                                                    <th>Pre-printed<br /> Barcode</th>
                                                    <th>Auto<br />Barcode</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {testSampleContainerList.length > 0 ? (
                                                    testSampleContainerList.map((item, idx) => (
                                                        <tr className="b2b-test-list-row">
                                                            {/*  Tests */}
                                                            <td style={{ width: '20%', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                                                {item.tests ? (
                                                                    item.tests.includes(",") ? (
                                                                        <Popover
                                                                            content={
                                                                                <ul className="list-unstyled" style={{ textAlign: "left", padding: 0, margin: 0 }}>
                                                                                    {item.tests.split(",").map((t, i) => (
                                                                                        <li key={i}>{t.trim()}</li>
                                                                                    ))}
                                                                                </ul>
                                                                            }
                                                                        >
                                                                            <span style={{ cursor: "pointer" }}>
                                                                                {item.tests.split(",")[0]} (+{item.tests.split(",").length - 1})
                                                                            </span>
                                                                        </Popover>
                                                                    ) : (
                                                                        item.tests
                                                                    )
                                                                ) : (
                                                                    "-"
                                                                )}
                                                            </td>

                                                            <td style={{ width: '15%' }}>{item.sampleContainer || "-"} / <br /> {item.sampleType || "-"} </td>

                                                            <td style={{ width: '10%' }}>{item.noOfVials || 0}</td>

                                                            <td style={{ width: '10%', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                                                {item.processingLocation ? (
                                                                    item.processingLocation.includes(",") ? (
                                                                        <Popover
                                                                            content={
                                                                                <ul className="list-unstyled" style={{ textAlign: "left", padding: 0, margin: 0 }}>
                                                                                    {item.processingLocation.split(",").map((loc, i) => (
                                                                                        <li key={i}>{loc.trim()}</li>
                                                                                    ))}
                                                                                </ul>
                                                                            }
                                                                        >
                                                                            <span style={{ cursor: "pointer" }}>
                                                                                {item.processingLocation.split(",")[0]} (+{item.processingLocation.split(",").length - 1})
                                                                            </span>
                                                                        </Popover>
                                                                    ) : (
                                                                        item.processingLocation
                                                                    )
                                                                ) : (
                                                                    "-"
                                                                )}
                                                            </td>


                                                            {userDetails?.Is_Avail_For_PrePrintedBarcode && (
                                                                <td style={{ width: "20%", padding: "3px", textAlign: "center" }}>
                                                                    {item.sampleContainer?.toUpperCase() === "NO CONTAINER" ||
                                                                        item.sampleType?.toUpperCase() === "NO SAMPLE" ? (
                                                                        <span style={{ fontSize: "12px", color: "gray" }}>
                                                                            Pre-printed barcode is not required
                                                                        </span>
                                                                    ) : (
                                                                        <div className="d-flex align-items-center justify-content-center">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                value={item.BarcodeId || ""}
                                                                                maxLength={CONTAINERSIZEVALIDATION}
                                                                                onChange={(e) => {
                                                                                    const val = e.target.value.replace(/[^0-9]/g, "");
                                                                                    const updatedList = [...testSampleContainerList];
                                                                                    updatedList[idx] = { ...updatedList[idx], BarcodeId: val };
                                                                                    setTestSampleContainerList(updatedList);

                                                                                    if (val.length === CONTAINERSIZEVALIDATION) {
                                                                                        const duplicate = updatedList.some(
                                                                                            (row, i) =>
                                                                                                i !== idx &&
                                                                                                row.sampleContainer === item.sampleContainer &&
                                                                                                row.BarcodeId === val
                                                                                        );
                                                                                        if (duplicate) {
                                                                                            toast.error(`Duplicate barcode detected for ${item.sampleContainer}`);
                                                                                            return;
                                                                                        }
                                                                                        ValidateContainerBarcodeId(item.sampleContainer, val);
                                                                                    }
                                                                                }}
                                                                                placeholder="Enter Pre-printed Barcode"
                                                                            />

                                                                            {/* Mobile only button */}
                                                                            {/* <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-outline-primary ms-2 d-flex d-lg-none"
                                                                                onClick={() => {
                                                                                    setActiveIndex(idx);
                                                                                    setShowScanner(true);
                                                                                }}
                                                                            >
                                                                                <i className="fa fa-camera"></i>
                                                                            </button> */}

                                                                            {/* Show Scanner */}
                                                                            {showScanner && activeIndex === idx && (
                                                                                <BarcodeScannerComponent
                                                                                    x onScan={(val) => {
                                                                                        const updated = [...testSampleContainerList];
                                                                                        updated[idx] = { ...updated[idx], BarcodeId: val };
                                                                                        setTestSampleContainerList(updated);
                                                                                        setShowScanner(false);
                                                                                        ValidateContainerBarcodeId(item.sampleContainer, val);
                                                                                    }}
                                                                                    onClose={() => setShowScanner(false)}
                                                                                />
                                                                            )}
                                                                        </div>

                                                                    )}
                                                                </td>

                                                            )}

                                                        </tr>

                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="13" className="text-center">No Sample/Container Info Available</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                </>

                                <>
                                    <div className="row mt-2">
                                        {/* Multiselect Dropdown */}
                                        <div className="col-md-6 col-12 mb-2">
                                            <label><b>Additional History:</b></label>
                                            <div onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}>
                                                <MultiSelect
                                                    options={activePatientHistoryList}
                                                    selectedValues={selectedPatientHistoryList}
                                                    onSelect={setSelectedPatientHistoryList}
                                                    onRemove={setSelectedPatientHistoryList}
                                                    displayValue="Key"
                                                    placeholder="Select Patient History"
                                                />
                                            </div>

                                        </div>

                                        <div className="col-md-6 col-12">
                                            <div className="d-flex align-items-end justify-content-between">
                                                <label className="mb-1"><b>Additional Info:</b></label>
                                                <small style={{ fontSize: "13px", fontWeight: "500" }}>
                                                    {additionalInfo.length}/{maxLengthForTextArea}
                                                </small>
                                            </div>
                                            <div>
                                                <textarea
                                                    rows={3}
                                                    className="form-control"
                                                    placeholder="Provide Patient or Test Information"
                                                    {...register("additionalInfo", {
                                                        maxLength: { value: maxLengthForTextArea, message: "Max 250 characters" },
                                                    })}
                                                />
                                                <div className="d-flex justify-content-between">
                                                    {errors.additionalInfo && (
                                                        <small className="text-danger">{errors.additionalInfo.message}</small>
                                                    )}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>

                                {/* Action Buttons */}
                                <div className="d-flex justify-content-between gap-2 mb-2 pt-2">
                                    <button type="button" onClick={() => navigate("/registrationlist")} className="btn btn-danger">Back</button>
                                    <button type="submit" disabled={SearchLoading} className="btn custom-sumbitbtn">Preview & Submit</button>
                                </div>


                                {/* <button type="button" className="btn btn-info">Save Draft</button> */}

                                {/* <div>
                                    <button onClick={openCamera}>Open Camera</button>
                                    <br />
                                    <video ref={videoRef} autoPlay width="320" height="240" />
                                    <br />
                                    <button onClick={takePhoto}>Capture</button>
                                    <br />
                                    <canvas ref={canvasRef} width="320" height="240" style={{ display: "none" }} />
                                    {photo && (
                                        <div>
                                            <h4>Captured Image:</h4>
                                            <img src={photo} alt="Captured" />
                                        </div>
                                    )}
                                </div> */}

                            </div>

                            {/* </div> */}

                        </form>

                        {showAttachDocumentModal && (
                            <div className="modal-backdrop">
                                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                                    <div className="modal-dialog modal-md" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header p-2">
                                                <h5 className="modal-title">Attach Patient Documents</h5>
                                                <button type="button" className="btn-close" onClick={handleAttachClose}></button>
                                            </div>

                                            <div className="modal-body">
                                                {patientAttachments.length > 0 && (
                                                    <div className="mb-3">
                                                        {/* <div className="card-body"> */}
                                                        <label className="form-label fw-bold">Uploaded Documents</label>
                                                        <ul className="list-group small">
                                                            {patientAttachments.map((att, idx) => (
                                                                <li className="list-group-item uploaded-docs-list-item d-flex justify-content-between align-items-center" key={idx}>
                                                                    {/* <span className="px-2" style={{ whiteSpace: "nowrap" }}><b>{att.urnOf?.charAt(0)}</b> - {att.urnFileType} ({att.urnNumber})</span> */}
                                                                    <span className="px-2" style={{ whiteSpace: "nowrap" }}>
                                                                        {att.urnOf && <b>{att.urnOf.charAt(0)}</b>}
                                                                        {att.urnOf ? " - " : ""}
                                                                        {att.urnFileType}
                                                                        {att.urnNumber ? ` (${att.urnNumber})` : ""}
                                                                    </span>


                                                                    <div className="d-flex align-items-center">
                                                                        <div title="View Document" style={{ cursor: "pointer" }} onClick={() => handleAttachmentDownload(att.urnFilePath)} className="view-doc-btn-wrapper">
                                                                            <FaEye color="green" size={19} />
                                                                        </div>
                                                                        <div style={{ cursor: "pointer" }} title="Delete Document" onClick={() => handleDeletePatientAttachment(idx)} className="delete-doc-btn-wrapper">
                                                                            <i
                                                                                style={{ fontSize: "14px" }}
                                                                                className="fas fa-trash-alt text-danger "
                                                                                role="button"
                                                                            ></i>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            ))}
                                                        </ul>

                                                        {/* </div> */}
                                                    </div>
                                                )}

                                                {/* <form onSubmit={handleAttachFile}> */}
                                                <div className="mb-2">
                                                    <label className="required">Select Attachment Type</label>
                                                    <select
                                                        className="form-select"
                                                        value={selectedDocType}
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            const id = e.target.options[e.target.selectedIndex].dataset.id;
                                                            const isUrn = e.target.options[e.target.selectedIndex].dataset.isUrn === "true";

                                                            setSelectedDocType(val);
                                                            setSelectedDocTypeId(id);
                                                            setIsUrnType(isUrn);

                                                            if (!isUrn) {
                                                                setSelectedOf("");
                                                                setDocNumber("");
                                                            }
                                                        }}
                                                        required
                                                    >
                                                        <option value="">-- Select Attachment Type --</option>
                                                        {activePatientAttachmentListData.map((item) => (
                                                            <option key={item.Data} data-id={item.Data} data-is-urn={item.Is_URN} value={item.Value}>
                                                                {item.Value}
                                                            </option>
                                                        ))}
                                                    </select>

                                                </div>

                                                {isUrnType && (
                                                    <>
                                                        <div className="row mb-2">
                                                            <div className="col-md-5">
                                                                <label className="required">Document Of</label>
                                                                <select
                                                                    className="form-select"
                                                                    value={selectedOf}
                                                                    onChange={(e) => setSelectedOf(e.target.value)}
                                                                    required={isUrnType}
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="Self">Self</option>
                                                                    <option value="Guest">Guest</option>
                                                                </select>
                                                            </div>

                                                            <div className="col-md-7">
                                                                <label className="required">Document ID</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={docNumber}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value.toUpperCase();
                                                                        if (/^[A-Z0-9-\s]*$/.test(value)) setDocNumber(value);
                                                                    }}
                                                                    maxLength={20}
                                                                    required={isUrnType}
                                                                />
                                                            </div>
                                                        </div>
                                                    </>
                                                )}


                                                <div className="row mb-2">
                                                    <div className="d-flex align-items-center col-md-12">
                                                        <input
                                                            id="uploadPatientFileInput"
                                                            type="file"
                                                            accept=".jpg,.jpeg,.bitmap,.pdf,.doc,.docx,.tiff,.msg,.eml,.zip"
                                                            className="form-control select-field me-2 select-field-patient-doc"
                                                            onChange={(e) => setSelectedFile(e.target.files[0])}
                                                            required
                                                            style={{ paddingRight: "40px" }}
                                                        />
                                                        <button
                                                            title="Open Camera"
                                                            type="button"
                                                            className="btn custom-sumbitbtn position-absolute d-none d-lg-flex justify-content-center align-items-center"
                                                            style={{
                                                                padding: "5px",
                                                                right: "0",
                                                                height: "35px",
                                                                width: "40px",
                                                                top: "50%",
                                                                fontSize: "13px",
                                                                transform: "translateY(-50%)",
                                                                marginRight: '11px'
                                                            }}
                                                            onClick={() => handleCameraButtonClick()}
                                                        // disabled={!selectedDocType || !selectedDocTypeId || !selectedOf || !docNumber}
                                                        >
                                                            <FaCamera size={14} />
                                                        </button>

                                                    </div>
                                                    {selectedFile && (
                                                        <div className="mt-2">
                                                            <strong>Selected File:</strong> {selectedFile?.name}
                                                        </div>
                                                    )}
                                                </div>
                                                {/* </form> */}
                                            </div>

                                            <div className="modal-footer p-1">

                                                <button
                                                    type="button"
                                                    className="btn custom-sumbitbtn"
                                                    onClick={handleAttachFile}
                                                    disabled={
                                                        isUploading ||
                                                        !selectedDocType ||
                                                        !selectedFile ||
                                                        (isUrnType && (!selectedOf || !docNumber))  // Only check when URN type
                                                    }
                                                >
                                                    {isUploading ? (
                                                        <div className="d-flex gap-2 align-items-center">
                                                            <FaSpinner className="fa-spin" />
                                                            Uploading...
                                                        </div>
                                                    ) : (
                                                        <> Upload </>
                                                    )}
                                                </button>

                                                <button type="button" className="btn btn-danger" onClick={handleAttachClose}>
                                                    Close
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {showTestWiseAttachmentModal && (
                            <div className="modal-backdrop">
                                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                                    <div className="modal-dialog modal-md" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header p-2">
                                                <h5 className="modal-title">Attach Document to Test</h5>
                                                <button type="button" className="btn-close" onClick={handleTestAttachmentClose}></button>
                                            </div>
                                            <div className="modal-body">

                                                {/* Attachment list (if any) */}
                                                {selectedTests[currentAttachmentIndex]?.TestAttachmentList?.length > 0 && (
                                                    <div className="mb-3">
                                                        <label className="form-label fw-bold">List of Attachments</label>
                                                        <ul className="list-group small">
                                                            {selectedTests[currentAttachmentIndex].TestAttachmentList.map((att, idx) => (
                                                                <li className="list-group-item d-flex justify-content-between align-items-center" key={idx}>
                                                                    <span>{att.type}</span>
                                                                    <div className="d-flex align-items-center">
                                                                        <a
                                                                            href={att.file_url}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            className="text-primary me-3"
                                                                            title="View"
                                                                        >
                                                                            <i className="fas fa-file-alt"></i>
                                                                        </a>
                                                                        <i
                                                                            className="fas fa-trash-alt text-danger"
                                                                            role="button"
                                                                            title="Delete"
                                                                            onClick={() => handleDeleteAttachment(idx)}
                                                                        ></i>
                                                                    </div>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                )}

                                                <div className="d-flex align-items-center mb-3">
                                                    <label className="me-2 fw-bold" style={{ whiteSpace: 'nowrap', minWidth: '150px' }}>
                                                        Select Document Type:
                                                    </label>
                                                    <select
                                                        className="form-select"
                                                        style={{ maxWidth: '300px' }}
                                                        value={selectedTestDocType}
                                                        onChange={(e) => setSelectedTestDocType(e.target.value)}
                                                        required
                                                    >
                                                        <option value="">-- Select --</option>
                                                        <option value="AADHAAR">AADHAAR</option>
                                                        <option value="Corporate Evidence">Corporate Evidence</option>
                                                        <option value="Identity Document">Identity Document</option>
                                                        <option value="Prescription">Prescription</option>
                                                        <option value="TRF">TRF</option>
                                                        <option value="URN">URN</option>
                                                    </select>
                                                </div>

                                                <div className="d-flex align-items-center mb-3">

                                                    <div className="input-group" style={{ maxWidth: '600px' }}>
                                                        <input
                                                            type="file"
                                                            accept=".jpg,.jpeg,.bitmap,.pdf,.doc,.docx,.tiff,.msg,.eml,.zip"
                                                            className="form-control"
                                                            onChange={(e) => setSelectedTestFile(e.target.files[0])}
                                                            required
                                                        />
                                                        <button
                                                            className="btn custom-sumbitbtn"
                                                            type="button"
                                                            onClick={handleTestWiseAttachFile}
                                                            disabled={!selectedTestDocType || !selectedTestFile}
                                                        >
                                                            Upload
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>

                                            <div className="modal-footer p-1">
                                                {/* <button
                                        type="button"
                                        className="btn btn-success"
                                        onClick={handleTestWiseAttachFile}
                                        disabled={!selectedTestDocType || !selectedTestFile}
                                    >
                                        Attach File
                                    </button> */}
                                                <button type="button" className="btn btn-danger" onClick={handleTestAttachmentClose}>
                                                    Close
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {showContainerModal && (
                            <div className="modal-backdrop">
                                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                                    <div className="modal-dialog modal-lg" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header p-2">
                                                <h5 className="modal-title">Sample & Container Info for <code>{selectedTestCode}</code></h5>
                                                <button type="button" className="btn-close" onClick={handleContainerModalClose}></button>
                                            </div>
                                            <div className="modal-body pb-0">
                                                {containerMatchList.length > 0 ? (
                                                    <div className="table-responsive-b2b-reg">
                                                        <table className="table table-bordered custom-table w-100">
                                                            <thead className="bg-success">
                                                                <tr>
                                                                    <th style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                                                                        {/* <th style={{ width: "50%", whiteSpace: "normal", wordBreak: "break-word" }}> */}
                                                                        Test Name
                                                                    </th>
                                                                    <th style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                                                                        {/* <th style={{ width: "25%", whiteSpace: "normal", wordBreak: "break-word" }}> */}
                                                                        Container
                                                                    </th>
                                                                    <th style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                                                                        {/* <th style={{ width: "25%", whiteSpace: "normal", wordBreak: "break-word" }}> */}
                                                                        Sample
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody className="patient-list-small-font">
                                                                {containerMatchList.map((item, idx) => (
                                                                    <tr key={idx}>
                                                                        <td style={{ width: "20%", whiteSpace: "normal", wordBreak: "break-word" }}>
                                                                            {item.TestName}
                                                                        </td>
                                                                        <td style={{ width: "25%", whiteSpace: "normal", wordBreak: "break-word" }}>
                                                                            {item.ContainerName || "-"}
                                                                        </td>
                                                                        <td style={{ width: "25%", whiteSpace: "normal", wordBreak: "break-word" }}>
                                                                            {item.SampleName || "-"}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                ) : (
                                                    <div className="text-danger">No container info found for this test.</div>
                                                )}
                                            </div>

                                            <div className="modal-footer p-1">
                                                <button type="button" className="btn btn-danger" onClick={handleContainerModalClose}>
                                                    Close
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {showTestHistoryModal && (
                            <div className="modal-backdrop">
                                {/* <FilePreviewModal
                                    fileUrl={previewUrl}
                                    onClose={() => setPreviewUrl(null)}
                                /> */}
                                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                                    <div className="modal-dialog modal-md" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header p-2">
                                                <h5 className="modal-title">
                                                    Add Patient History for{" "}
                                                    {selectedTestIndex != null && selectedTests[selectedTestIndex] && (
                                                        <code>{selectedTests[selectedTestIndex].TestCode}</code>
                                                    )}
                                                </h5>
                                                <button type="button" className="btn-close" onClick={() => handlePatientHistoryClose()}></button>
                                            </div>

                                            <div className="modal-body" style={{ maxHeight: 420, overflowY: "auto" }}>
                                                {historyFields.map((field, index) => {
                                                    const { HistoryAttribute, HistoryName, Is_Mandatory, Options = [] } = field;
                                                    // const updateField = (patch) => {
                                                    //     const updated = [...historyFields];
                                                    //     updated[index] = { ...updated[index], ...patch };
                                                    //     setHistoryFields(updated);
                                                    //     //console.log("updated", updated);
                                                    // };

                                                    return (
                                                        <div key={index}>
                                                            <div className="mb-2">
                                                                <label className="form-label">
                                                                    {HistoryName} {Is_Mandatory && <span className="text-danger">*</span>}
                                                                </label>

                                                                {/* TextBox */}
                                                                {HistoryAttribute === "TextBox" && (
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={field.HistoryValue || ""}
                                                                        maxLength={200}
                                                                        required={Is_Mandatory}
                                                                        onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            const regex = /^[`#*()_\\\-;’:”,./\w\s]*$/;

                                                                            if (!regex.test(value)) return;

                                                                            updateField({ HistoryValue: value }, index);
                                                                        }}
                                                                    />

                                                                )}

                                                                {/* Date Picker */}
                                                                {/* {HistoryAttribute === "DateTime" && (
                                                                    <input
                                                                        type="date"
                                                                        className="form-control"
                                                                        value={field.HistoryValue || ""}
                                                                        required={Is_Mandatory}
                                                                        max={new Date().toISOString().split("T")[0]}
                                                                        onChange={(e) => updateField({ HistoryValue: e.target.value }, index)}
                                                                    />
                                                                )} */}

                                                                {field.HistoryAttribute === "DateTime" && (
                                                                    <input
                                                                        type="datetime-local"
                                                                        className="form-control"
                                                                        value={field.selectedDateTime || ""}
                                                                        onChange={(e) => {
                                                                            const date = e.target.value;
                                                                            let formatted = "";

                                                                            if (date) {
                                                                                formatted = new Date(date)
                                                                                    .toLocaleString("en-GB", {
                                                                                        day: "2-digit",
                                                                                        month: "short",
                                                                                        year: "numeric",
                                                                                        hour: "2-digit",
                                                                                        minute: "2-digit",
                                                                                        hour12: true
                                                                                    })
                                                                                    .replace(",", "")
                                                                                    .replace(/\s?(am|pm)/i, (m) => m.toUpperCase());
                                                                            }

                                                                            updateField(
                                                                                { selectedDateTime: date, HistoryValue: formatted },
                                                                                index
                                                                            );
                                                                        }}
                                                                    />

                                                                )}

                                                                {field.HistoryAttribute === "DropDown" && (
                                                                    <select
                                                                        className="form-select"
                                                                        value={field.selectedOption || ""}
                                                                        required={Is_Mandatory}
                                                                        onChange={(e) => {
                                                                            const val = e.target.value;
                                                                            updateField(
                                                                                { selectedOption: val, HistoryValue: val },
                                                                                index
                                                                            );
                                                                        }}
                                                                    >
                                                                        <option value="">Select</option>
                                                                        {field.Options?.map((opt, i) => (
                                                                            <option key={i} value={opt}>{opt}</option>
                                                                        ))}
                                                                    </select>

                                                                )}

                                                                {/* Attachment */}
                                                                {HistoryAttribute === "Attachement" && (
                                                                    <>
                                                                        {/* Document Type */}
                                                                        <select
                                                                            className="form-select mb-2"
                                                                            value={field.urnFileType || ""}
                                                                            onChange={(e) => {
                                                                                updateField({
                                                                                    urnFileType: e.target.value,
                                                                                    urnOf: "",
                                                                                    urnNumber: "",
                                                                                    urnFilePath: "",
                                                                                    selectedHistoryFile: null,
                                                                                    HistoryValue: ""
                                                                                }, index);
                                                                                if (fileInputRefs.current[index]) {
                                                                                    fileInputRefs.current[index].value = "";
                                                                                    setSelectedFile(null)
                                                                                }
                                                                            }}
                                                                        >
                                                                            <option value="">Select Document Type</option>
                                                                            {Options.map((opt, i) => (
                                                                                <option key={i} value={opt}>{opt}</option>
                                                                            ))}
                                                                        </select>



                                                                        {/* File Upload */}
                                                                        <div className="d-flex gap-2 align-items-center">
                                                                            <div className="position-relative flex-grow-1">
                                                                                <input
                                                                                    ref={(el) => (fileInputRefs.current[index] = el)}
                                                                                    type="file"
                                                                                    accept=".jpg,.jpeg,.bitmap,.pdf,.doc,.docx,.tiff,.msg,.eml,.zip"
                                                                                    className="form-control select-field-patient-history"
                                                                                    onChange={(e) => {
                                                                                        const file = e.target.files?.[0];
                                                                                        updateField({ selectedHistoryFile: file }, index);
                                                                                        setSelectedFile(file);
                                                                                    }}
                                                                                    style={{ paddingRight: "45px" }}
                                                                                />

                                                                                <button
                                                                                    title="Open Camera"
                                                                                    type="button"
                                                                                    className="btn custom-sumbitbtn position-absolute d-none d-lg-flex justify-content-center align-items-center"
                                                                                    style={{
                                                                                        padding: "5px",
                                                                                        right: "1px",
                                                                                        height: "calc(100% - 2px)",
                                                                                        width: "40px",
                                                                                        top: "1px",
                                                                                        fontSize: "13px",
                                                                                    }}
                                                                                    onClick={() => { handleCameraButtonClick(); setTestIndex(index) }}
                                                                                // disabled={!field.urnFileType || !field.urnOf || !field.urnNumber}
                                                                                >
                                                                                    <FaCamera size={14} />
                                                                                </button>
                                                                            </div>

                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm custom-sumbitbtn"
                                                                                onClick={() => handleHistoryAttriAttachFile(index)}
                                                                                disabled={isUploadingForHistory || !field.urnFileType || !field.selectedHistoryFile} //|| !field.selectedHistoryFile
                                                                                style={{ padding: '5px 8px' }}
                                                                            >
                                                                                {isUploadingForHistory ? (
                                                                                    <div className="d-flex gap-2 align-items-center">
                                                                                        <FaSpinner className="fa-spin" />
                                                                                        Uploading...
                                                                                    </div>
                                                                                ) : (
                                                                                    <>
                                                                                        Upload
                                                                                    </>
                                                                                )}
                                                                            </button>

                                                                        </div>
                                                                        {selectedFile && (
                                                                            <div className="mt-2">
                                                                                <strong>Selected File:</strong> {selectedFile?.name}
                                                                            </div>
                                                                        )}

                                                                        {/* Uploaded File Link */}
                                                                        {field.HistoryAttachments?.length > 0 && (() => {
                                                                            // Build counters per fileType
                                                                            const typeCounters = {};

                                                                            return (
                                                                                <ul className="list-group small mt-2">
                                                                                    {field.HistoryAttachments.map((att, idx) => {

                                                                                        // Increment counter for each fileType
                                                                                        if (!typeCounters[att.fileType]) {
                                                                                            typeCounters[att.fileType] = 1;
                                                                                        } else {
                                                                                            typeCounters[att.fileType]++;
                                                                                        }

                                                                                        const displayIndex = typeCounters[att.fileType];

                                                                                        return (
                                                                                            <li
                                                                                                key={idx}
                                                                                                className="list-group-item uploaded-docs-list-item d-flex justify-content-between align-items-center"
                                                                                            >
                                                                                                <span className="px-2" style={{ whiteSpace: "nowrap" }}>
                                                                                                    <b>{att.fileType?.charAt(0)}</b> - {att.fileType} | Attachment {displayIndex}
                                                                                                </span>

                                                                                                <div className="d-flex align-items-center gap-2">
                                                                                                    <div
                                                                                                        title="View Document"
                                                                                                        style={{ cursor: "pointer" }}
                                                                                                        onClick={() => handleAttachmentDownload(att.filePath)}
                                                                                                        className="view-doc-btn-wrapper"
                                                                                                    >
                                                                                                        <FaEye color="green" size={18} />
                                                                                                    </div>

                                                                                                    <div
                                                                                                        title="Delete Document"
                                                                                                        style={{ cursor: "pointer" }}
                                                                                                        onClick={() => handleDeleteHistoryAttachment(index, idx)}
                                                                                                        className="delete-doc-btn-wrapper"
                                                                                                    >
                                                                                                        <i className="fas fa-trash-alt text-danger" style={{ fontSize: "15px" }}></i>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </li>
                                                                                        );
                                                                                    })}
                                                                                </ul>
                                                                            );
                                                                        })()}


                                                                    </>
                                                                )}
                                                            </div>

                                                            {/* Separator */}
                                                            {index < historyFields.length - 1 && <hr />}
                                                        </div>
                                                    );
                                                })}
                                            </div>

                                            <div className="modal-footer p-1">
                                                <button type="button" className="btn btn-danger" onClick={() => handlePatientHistoryClose()}>
                                                    Close
                                                </button>
                                                <button type="button" className="btn custom-sumbitbtn" onClick={handleSavePatientHistory}>
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Suggestion Model */}
                        {suggestionModel && (
                            <>
                                {/* Backdrop */}
                                <div
                                    className="modal-backdrop fade show"
                                    onClick={() => setSuggestionModel(false)}
                                />
                                <div className="modal fade show d-block success" tabIndex="-1"
                                >
                                    <div className="modal-dialog modal-md">
                                        <div className="modal-content">
                                            <div className="modal-header custom-card-heading text-white p-2">
                                                <h5 className="modal-title text-white px-2">Frequently Booked Tests</h5>
                                                <button type="button" className="btn-close btn-close-white mr-1" disabled={isSubmitting} onClick={() => setSuggestionModel(false)}></button>
                                            </div>
                                            <div className="modal-body">

                                                <div >
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search by Test Name, Code"
                                                        ref={selectedSearchTestName}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        onChange={(e) => {
                                                            const value = e.target.value
                                                                .toUpperCase()
                                                                .replace(/[^A-Z0-9_\s]/g, "");

                                                            setSearchText(value);

                                                            if (!value.trim()) {
                                                                setFilteredTests(testSuggestions);
                                                                return;
                                                            }

                                                            const filtered = testSuggestions.filter((item) =>
                                                                item.TestName.toUpperCase().includes(value) ||
                                                                item.TestCode.toUpperCase().includes(value)
                                                            );

                                                            setFilteredTests(filtered);
                                                        }}
                                                        style={{ paddingRight: "40px" }}
                                                    />

                                                    <div className="my-3">
                                                        <div
                                                            style={{
                                                                maxHeight: "300px",
                                                                overflowY: "auto",
                                                                borderRadius: "6px"
                                                            }}
                                                        >
                                                            <ul
                                                                className="list-group"
                                                                style={{
                                                                    borderRadius: "6px",
                                                                }}
                                                            >
                                                                {filteredTests.length === 0 ? (
                                                                <li
                                                                    className="list-group-item text-center text-muted"
                                                                    style={{ fontSize: "13px" }}
                                                                >
                                                                    No data found
                                                                </li>
                                                                ) : (filteredTests.map((item) => {
                                                                    const isAdded = selectedTests.some(
                                                                        (t) => t.TestCode === item.TestCode
                                                                    );

                                                                    const isLoading =
                                                                        SearchLoading && loadingItem === item.Id;

                                                                    return(
                                                                    <li
                                                                        key={item.TestCode}
                                                                        className="list-group-item d-flex justify-content-between align-items-center"
                                                                        style={{
                                                                            fontSize: "13px",
                                                                            borderColor: "#ccc",
                                                                            backgroundColor: "transparent"
                                                                        }}
                                                                    >
                                                                        <span style={{width: "370px"}}>
                                                                            {item?.TestName} (<b>{item?.TestCode}</b>)
                                                                        </span>

                                                                        <button
                                                                            type="button"
                                                                            disabled={
                                                                                isAdded ||
                                                                                (SearchLoading && loadingItem !== null)
                                                                            }
                                                                            className={`btn btn-sm custom-sumbitbtn py-1 ${
                                                                                isAdded ? "suggestion-selected" : ""
                                                                            }`}
                                                                            onClick={() => handleAddTestFromSuggestion(item)}
                                                                            title={isAdded ? "Already added" : "Add test"}
                                                                        >
                                                                            {isLoading ? (
                                                                                <FaSpinner className="fa-spin d-flex" />
                                                                            ) : isAdded ? (
                                                                                <FaCheck className="d-flex" />
                                                                            ) : (
                                                                                <FaPlus className="d-flex" />
                                                                            )}
                                                                        </button>
                                                                    </li>
                                                                );
                                                                    })
                                                                )}
                                                            </ul>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                        {/* Preview Modal */}
                        {showPreview && previewData && (
                            <>
                                <div className="modal-backdrop" > </div>
                                <div className="modal fade show d-block success" tabIndex="-1"
                                // style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                                >
                                    <div className="modal-dialog modal-lg">
                                        <div className="modal-content">
                                            <div className="modal-header custom-card-heading text-white p-2">
                                                <h5 className="modal-title text-white px-2">Patient TRF Summary</h5>
                                                <button type="button" className="btn-close btn-close-white mr-1" disabled={isSubmitting} onClick={() => setShowPreview(false)}></button>
                                            </div>
                                            <div className="modal-body">

                                                {/* Patient Details */}
                                                <h6 className="mb-2"><strong>Patient Details</strong></h6>
                                                <div className="row">
                                                    <div className="d-flex flex-wrap w-100 mb-1">
                                                        <span className="me-1" style={{ fontWeight: '500' }}>Name:</span>
                                                        <span>
                                                            {previewData?.Salutation || ""}{" "}
                                                            {previewData?.FirstName || ""}{" "}
                                                            {previewData?.MiddleName || ""}{" "}
                                                            {previewData?.LastName || ""}
                                                        </span>
                                                    </div>
                                                    <div className="col-md-6" style={{ borderRight: '1px solid #ccc' }}>
                                                        <p className="case-details"><p>DOB:</p> {previewData.Dob ? new Date(previewData.Dob).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "-"}({previewData.PatientAge})</p>
                                                        {/* <p className="case-details"><p>Age:</p> {previewData.PatientAge}</p> */}
                                                        <p className="case-details"><p>Mobile:</p> {previewData.MobileNumber || "-"}</p>

                                                    </div>
                                                    <div className="col-md-6">
                                                        {/* <p className="case-details"><p>Email:</p> {previewData.Email || "-"}</p>
                                                        <p className="case-details"><p>Dr. Name:</p> {previewData.DoctorName || "-"}</p> */}
                                                        {/* <p className="case-details-address"><p>Address:</p> {
                                                            [previewData.Address1, previewData.Address2].filter(Boolean).join(" ")
                                                                ? [previewData.Address1, previewData.Address2].filter(Boolean).join(" ") + (previewData.Pincode ? ", " + previewData.Pincode : "")
                                                                : (previewData.Pincode || "-")
                                                        }</p> */}
                                                        <p className="case-details"><p>Gender:</p> {previewData.Gender}</p>

                                                        <div className="case-details-address">
                                                            <p>Address:</p>
                                                            <div>
                                                                <span
                                                                    ref={textRef}
                                                                    className={`mb-1 text-start address-text ${!isExpanded ? 'text-truncate-custom' : ''}`}
                                                                    style={{
                                                                        display: '-webkit-box',
                                                                        WebkitLineClamp: !isExpanded ? maxLines : 'none',
                                                                        WebkitBoxOrient: 'vertical',
                                                                        overflow: 'hidden',
                                                                        lineHeight: '1.5'
                                                                    }}
                                                                >
                                                                    {previewData?.PincodeAddress || "-"}
                                                                </span>

                                                                {showReadMore && (
                                                                    <button
                                                                        onClick={toggleExpanded}
                                                                        className="btn btn-link p-0 text-decoration-none"
                                                                        style={{
                                                                            color: '#007bff',
                                                                            fontSize: 'x-small',
                                                                            cursor: 'pointer',
                                                                            border: 'none',
                                                                            background: 'none'
                                                                        }}
                                                                    >
                                                                        {isExpanded ? 'Show less' : 'Show More'}
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                                {/* Test Details */}
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <h6 className="mt-3 mb-2"><strong>Lab Investigations</strong>&nbsp;
                                                        {/* <span style={{ fontWeight: "500" }}>Total</span> */}
                                                        ({previewData.PatientTestList ? previewData.PatientTestList.length : 0})</h6>
                                                    {/* <span className="mt-3 mb-2">
                                                       
                                                    </span> */}
                                                    <span className="mt-3 mb-2"><span style={{ fontWeight: "500" }}>Sample Date/Time: </span>
                                                        {new Date(previewData.SampleCollectionDateTime).toLocaleString("en-GB", {
                                                            day: "2-digit",
                                                            month: "short",
                                                            year: "numeric",
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            hour12: true,
                                                        }).replace(",", "").replace(/\s?(am|pm)/i, (match) => match.toUpperCase())}
                                                    </span>
                                                </div>
                                                <div style={{ maxHeight: '180px', overflowY: 'auto' }} className="table-responsive-trf-summary mb-1">
                                                    <table className="table table-bordered custom-table mb-1">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th style={{ width: "50%" }}>Name</th>
                                                                <th>Code</th>
                                                                <th>Type</th>
                                                                <th>Processing Location</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {previewData.PatientTestList?.map((test, idx) => (
                                                                <tr key={idx}>
                                                                    <td style={{
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        maxWidth: '220px',
                                                                        cursor: test.TestName && test.TestName.length > 25 ? 'pointer' : 'default',
                                                                        position: 'relative'
                                                                    }}
                                                                        title={test.TestName && test.TestName.length > 25 ? test.TestName : ''}
                                                                    >
                                                                        {test.TestName && test.TestName.length > 25
                                                                            ? test.TestName.slice(0, 25) + '...'
                                                                            : test.TestName}
                                                                    </td>
                                                                    <td>{test.TestCode}</td>
                                                                    <td>{test.TestType}</td>
                                                                    <td>{test.ProcessingLocation}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>

                                                {/* <div className="d-flex justify-content-between mt-3">
                                                    <strong>Total Amount: ₹{previewData.TotalAmount}</strong>
                                                    <span><b>Sample Date/Time:</b> 
                                                        {new Date(previewData.SampleCollectionDateTime).toLocaleString("en-GB", {
                                                            day: "2-digit",
                                                            month: "short",
                                                            year: "numeric",
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            hour12: true,
                                                        }).replace(",", "").replace(/\s?(am|pm)/i, (match) => match.toUpperCase())}
                                                    </span>
                                                </div> */}

                                            </div>
                                            <div className="modal-footer p-2">
                                                {/* <button type="button" className="btn btn-danger" onClick={() => setShowPreview(false)}>Close</button> */}
                                                <button
                                                    type="button"
                                                    disabled={isSubmitting}
                                                    className="btn custom-sumbitbtn"
                                                    onClick={handleConfirmSubmit}
                                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                >
                                                    {isSubmitting ? (
                                                        <>
                                                            <FaSpinner className="fa-spin" /> &nbsp; Please Wait...
                                                        </>
                                                    ) : (<>
                                                        Submit
                                                    </>)}

                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                        {cameraModal && (
                            <CameraComponent handleCameraModalClose={handleCameraModalClose} setSelectedFile={setSelectedFile} />
                        )}


                        {/* {showPreview && (
                            <div className="modal fade show d-block" tabIndex="-1">
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header p-2">
                                            <h5 className="modal-title">Preview Patient Information</h5>
                                            <button type="button" className="btn-close" onClick={() => setShowPreview(false)}></button>
                                        </div>

                                        <div className="modal-body p-2" style={{ maxHeight: 500, overflowY: "auto" }}>
                                            {previewData && (
                                                <>
                                                    <ul className="small mb-3">
                                                        <li><b>Name:</b> {previewData.Salutation} {previewData.FirstName} {previewData.LastName}</li>
                                                        <li><b>Gender:</b> {previewData.Gender}</li>
                                                        <li><b>DOB:</b> {previewData.Dob}</li>
                                                        <li><b>Age:</b> {previewData.Age}</li>
                                                        <li><b>Mobile:</b> {previewData.MobileNumber}</li>
                                                    </ul>
                                                    <table className="table table-sm table-bordered">
                                                        <thead><tr><th>Code</th><th>Name</th><th>MRP</th><th>Location</th><th>TAT</th></tr></thead>
                                                        <tbody>
                                                            {previewData.PatientTestList.map((t, i) => (
                                                                <tr key={i}><td><code>{t.TestCode}</code></td><td>{t.TestName}</td><td>{t.Mrp}</td><td>{t.ProcessingLocation}</td><td>{t.TestTat}</td></tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                    <div className="text-end fw-bold">Total: ₹{previewData.TotalAmount}</div>
                                                </>
                                            )}
                                        </div>

                                        <div className="modal-footer p-2">
                                            <button className="btn btn-danger" onClick={() => setShowPreview(false)}>Cancel</button>
                                            <button className="btn btn-primary" disabled={SearchLoading} onClick={handleConfirmSubmit}>Confirm & Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )} */}



                        {/* {fileUrl && (
                            <div
                                style={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    backgroundColor: "rgba(0,0,0,0.5)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    zIndex: 9999
                                }}
                            >
                                <div
                                    style={{
                                        background: "#fff",
                                        width: "80%",
                                        height: "80%",
                                        position: "relative",
                                        borderRadius: "8px",
                                        overflow: "hidden"
                                    }}
                                >
                                    <button
                                        onClick={() => setFileUrl(null)}
                                        style={{
                                            position: "absolute",
                                            top: "10px",
                                            right: "10px",
                                            background: "red",
                                            color: "#fff",
                                            border: "none",
                                            padding: "5px 10px",
                                            cursor: "pointer",
                                            zIndex: 1
                                        }}
                                    >
                                        Close
                                    </button>
                                    <div style={{ padding: "25px", height: "100%", boxSizing: "border-box" }}>
                                        <iframe
                                            src={fileUrl}
                                            title="File Preview"
                                            width="100%"
                                            height="100%"
                                            style={{
                                                border: "none",
                                                background: "#f9f9f9", // optional light background
                                                borderRadius: "8px",
                                                padding: "10px", // space inside iframe content (only applies if content allows)
                                                margin: "10px"   // space outside iframe
                                            }}
                                        />
                                    </div>

                                </div>
                            </div>
                        )} */}
                        {/* <FilePreviewModal show={!!fileUrl} fileUrl={fileUrl} onClose={() => setFileUrl(null)} /> */}

                    </div>

                </div>
            </div >
        </div >

    );
};

export default B2bRegistrationComponent;
